{
    "brand": "Fireknife",
    "welcome": "Üdvözöljük az i18n demóban!",
    "errors": {
        "invalidCredentials": "Érvénytelen hitelesítő adatok",
        "unauthorizedToAdd": "Nincs jogosultsága hozzáadni",
        "unauthorizedToEdit": "Nincs jogosultsága szerkeszteni",
        "unauthorizedToDelete": "Nincs jogosultsága törölni",
        "unauthorizedToResetTwoFactor": "Nincs jogosultsága a kétfaktoros hitelesítés visszaállítására",
        "unauthorizedToGet": "Nincs jogosultsága megtekinteni",
        "unauthorizedToToggle": "Nincs jogosultsága kapcsolni",
        "unauthorizedToImport": "Nincs jogosultsága importálni a FareHarbor rendszeréből",
        "doesNotExist": "nem létezik",
        "notFound": "Nem található",
        "areRequired": "kötelező",
        "areRequiredParams": "Hiányzó kötelező mezők",
        "alreadyExists": "Már létezik",
        "alreadyExistsAtTheSameVenue": "Már létezik ehhez a helyszínhez",
        "alreadyExistsForTheSameShow": "Már létezik ehhez a műsorhoz",
        "commissionGroupAlreadyAssigned": "A felhasználó már egy másik jutalékcsoporthoz van rendelve ehhez a műsorhoz",
        "affiliateCodeGeneration": "Nem sikerült egyedi affiliate kódot generálni",
        "checkinClosed": "A check-in le van zárva ehhez az időponthoz",
        "email": "Nem megfelelő e-mail cím formátum",
        "notAllowedToAdd": "Nincs jogosultsága hozzáadni",
        "notAllowedToDelete": "Nincs jogosultsága törölni",
        "notAllowedToEdit": "Nincs jogosultsága szerkeszteni",
        "notAllowedToGet": "Nincs jogosultsága megtekinteni",
        "seatsDoNotBelong": "Az ülőhelyek nem tartoznak ehhez a műsorhoz",
        "invalidPaymentType": "Érvénytelen fizetési mód",
        "invalidRole": "Érvénytelen szerepkör",
        "emailAlreadyExists": "Ez az e-mail cím már létezik ehhez a helyszínhez",
        "unauthorizedToDelegate": "Nincs jogosultsága delegálni ezeket a képességeket",
        "cannotRemoveOwnUsersManage": "Nem távolíthatja el saját felhasználókezelési jogosultságát",
        "userIsNotConnectedToThisVenue": "Ez a felhasználó nincs kapcsolva ehhez a helyszínhez",
        "notAllowedToSwitchVenues": "Nincs jogosultsága helyszínt váltani",
        "noAuthHeader": "Nincs megadva hitelesítési fejléc!",
        "sessionExpired": "A munkamenet lejárt, kérlek jelentkezz be újra!",
        "invalidJWT": "Érvénytelen JWT token",
        "invalidBearerFormat": "A hitelesítési fejlécnek Bearer formátumban kell lennie",
        "unauthorized": "Nincs jogosultság",
        "alreadyInTheDesiredState": "Már a kívánt állapotban van",
        "unauthorizedToTriggerThisAction": "Nincs jogosultsága ehhez a művelethez",
        "orderNotPending": "A rendelés nem függőben lévő állapotban van",
        "unauthorizedToCancelReservation": "Nincs jogosultsága a foglalás lemondására",
        "unauthorizedToRefundReservation": "Nincs jogosultsága a foglalás visszafizetésére",
        "rollbackTimeNotSet": "A visszafizetési idő nincs beállítva",
        "invalidDate": "Érvénytelen dátum — érvényes jövőbeli dátumnak kell lennie",
        "rollbackTimeMustBeLater": "Az új visszafizetési időnek későbbinek kell lennie a jelenleginél",
        "noTicketsInCart": "Legalább egy jegy szükséges",
        "tripadvisorDataNotFound": "Tripadvisor adat nem található a megadott linken",
        "tripadvisorUrlInvalid": "A Tripadvisor URL formátuma nem megfelelő",
        "tripadvisorDataFetchError": "Hiba történt a Tripadvisor adatok lekérésekor",
        "unauthorizedToModifyTickets": "Nincs jogosultsága a jegyek módosítására",
        "cannotModifyTicketsPendingOrder": "A jegyek nem módosíthatók, mert a rendelés függőben lévő állapotban van",
        "cannotModifyTickets": "A jegyek nem módosíthatók",
        "duplicateTicketSeats": "Duplikált jegy ülőhelyek találhatók. Kérlek ellenőrizd a jegy ülőhelyeket!",
        "missingTicketSeat": "Egy jegyhez hiányzik az ülőhely, pedig szükséges lenne.",
        "invalidTicketSeat": "Érvénytelen jegy ülőhely. Kérlek ellenőrizd a jegy ülőhelyeket!",
        "seatAlreadyUsedInAnotherBooking": "Ez az ülőhely már használatban van egy másik foglalásban. Kérlek ellenőrizd a jegy ülőhelyeket! Ülőhely: {{seatIds}}",
        "duplicateSeatsInBatch": "Duplikált ülőhely-hozzárendelés a kérésben",
        "seatNotCompatibleWithTicketType": "A(z) {{seatId}} ülőhely nem kompatibilis a jegytípussal",
        "bookingItemsMismatch": "A foglalási tételek nem egyeznek a foglalásban szereplő jegyekkel. Kérlek töltsd újra a foglalást!",
        "fareharborImportError": "Hiba történt az adatok importálása során a FareHarbor rendszerből!",
        "widgetSlugNotFound": "A widget slug nem található, kérlek ellenőrizd az admin felületen a helyes slugot.",
        "widgetLoadingError": "Hiba történt a widget betöltésekor.",
        "bookingCancellationNotAllowedBefore": "A foglalás lemondása nem engedélyezett a(z) {{time}} órán belül.",
        "cancelReservationError": "Hiba történt a foglalás lemondásakor.",
        "guestCancellationDisabled": "Az önálló vendéglemondás ennél az előadásnál nem engedélyezett.",
        "noOffersSelected": "Nincs kiválasztott ajánlat a visszafizetéshez.",
        "noChunksSelected": "Nincs kiválasztott rész a visszafizetéshez.",
        "unknownError": "Ismeretlen hiba történt",
        "refundReservationError": "Hiba történt a foglalás visszafizetésekor.",
        "invalidAmount": "Érvénytelen visszafizetési összeg",
        "maxRefundExceeded": "A visszafizetési összeg meghaladja a maximális engedélyezett összeget",
        "invalidPaymentMethod": "Érvénytelen fizetési mód",
        "unsupportedPaymentMethod": "Nem támogatott fizetési mód: {{method}}",
        "notEnoughFundsForRefund": "Nincs elegendő pénz a visszafizetéshez. Tétel: {{chunkName}}, Összeg: {{amount}}",
        "invalidTransactionId": "Érvénytelen tranzakció azonosító",
        "transactionNotFound": "Tranzakció nem található",
        "transactionAlreadyFinished": "A tranzakció már befejeződött",
        "onlyCashTransactions": "Csak készpénzes tranzakciók fejezhetők be manuálisan",
        "transactionMustBeRefunding": "A tranzakciónak visszatérítés alatt kell állnia",
        "noVenueAccess": "Nincs hozzáférés a kiválasztott helyszínhez",
        "timeslotInPast": "Nem lehet múltbeli időpontot foglalni",
        "bookingWindowClosed": "Erre az időpontra már lezárult a foglalás",
        "timeslotCancelled": "Ezt az időpontot lemondták, és már nem foglalható",
        "createReservationError": "Hiba történt a foglalás létrehozásakor!",
        "createReservationErrorDetails": "Nem sikerült foglalást létrehozni. Kérjük, próbálja újra később, vagy lépjen kapcsolatba az ügyfélszolgálattal. A hiba részletei:",
        "blockLimitExceeded": "A jegytípus blokk limitje túllépve",
        "priceMismatch": "Ár eltérés",
        "timeslotHasActiveBookings": "Az időpontnak aktív foglalásai vannak",
        "timeslotHasOnlyCancelledBookings": "Az időpontnak csak törölt foglalásai vannak",
        "notEnoughSeatsProvided": "Nincs elegendő ülőhely megadva a jegytípushoz",
        "invalidSeatSelections": "Érvénytelen ülőhely-kijelölés",
        "invalidPrice": "Érvénytelen ár",
        "duplicateTimeslotPrice": "Ismétlődő ár ugyanahhoz a jegytípushoz és opcióhoz",
        "errorWhileTryingToPayReservation": "Hiba történt a foglalás kifizetésekor",
        "noFilePresentInRequest": "A kérésben legalább egy fájlnak jelen kell lennie!",
        "invalidSuggestion": "A jelenlegi elrendezés és követelmények mellett a helyfoglalás nem teljesíthető",
        "cannotSendSeatingLockEmailBeforeAllAssigned": "A helyfoglaló e-mail csak akkor küldhető, ha minden befejezett foglaláshoz hely hozzá van rendelve",
        "failedToSendSeatingLockEmails": "Nem sikerült elküldeni a helyfoglaló e-maileket",
        "failedToSendSeatingChangedEmail": "Nem sikerült elküldeni az ülőhely-változás e-mailt",
        "cannotSendSeatingChangedEmailForNonFinishedBooking": "A helyfoglalás-változás e-mail csak véglegesített foglaláshoz küldhető",
        "noEmailAddress": "Ehhez a foglaláshoz nincs megadva e-mail cím",
        "somethingWentWrong": "Hiba történt!",
        "transactionFailed": "Tranzakció sikertelen!",
        "cannotBuyAlone": "Ez a jegytípus nem vásárolható meg egyedül. Kérlek, válassz egy másik jegytípust is.",
        "adultTicketRequired": "Gyermek vagy csecsemő jegy foglalásakor legalább egy felnőtt jegy szükséges.",
        "cannotMixTicketTypes": "Ezen az előadáson foglalásonként csak egyféle jegytípus megengedett.",
        "agentCannotMixTicketTypes": "A fiókod nem menthet több jegytípust tartalmazó foglalást. Az azonos típusú upgrade továbbra is engedélyezett.",
        "invalidFormat": "Érvénytelen formátum",
        "viatorInvalidCredentials": "Viator API hitelesítő adatok érvénytelenek",
        "viatorIntegrationNotFound": "Viator integráció nem található",
        "timeslotMustBeSameShow": "Az új időpont ugyanahhoz az előadáshoz kell tartozzon",
        "invalidRentalSlot": "Ez a jegyopció nem érhető el a kiválasztott bérlési sávra",
        "invalidSlotDuration": "A sáv időtartama pozitív perc érték kell legyen",
        "duplicateSlotKey": "Minden bérlési sávnak egyedi kulccsal kell rendelkeznie",
        "ticketTypeMismatch": "A hely nem egyezik a hozzárendelt jegytípussal",
        "twoFactorAlreadyEnabled": "A kétfaktoros hitelesítés már engedélyezve van",
        "seatNotAvailable": "Ez az ülőhely nem elérhető a kiválasztott elrendezésben",
        "verificationFailed": "A kosár ellenőrzése sikertelen. Kérjük, ellenőrizze a kiválasztást és próbálja újra.",
        "verifying": "Kosár ellenőrzése...",
        "generationServiceUnavailable": "A szkriptgenerálás nem érhető el ezen a szerveren. Az engedélyezéshez állítsa be az OPENROUTER_API_KEY-t.",
        "generationFailed": "A szkriptet nem sikerült generálni",
        "fieldRequired": "{{field}} kötelező",
        "customFieldRequired": "A(z) „{{field}}\" kötelező"
    },
    "labelRowsPerPage": "Sorok száma oldalanként",
    "search": "Keresés",
    "searchPlaceholder": "Keresés...",
    "common": {
        "minutesAbbr": "perc",
        "actions": "Műveletek",
        "notFound": "Az oldal nem található.",
        "noContent": "Nincs elérhető tartalom.",
        "backToLogin": "Vissza a bejelentkezéshez",
        "backToHome": "Vissza a főoldalra",
        "accessDenied": "Hozzáférés megtagadva",
        "logout": "Kijelentkezés",
        "cancel": "Mégse",
        "close": "Bezárás",
        "clear": "Törlés",
        "clearAll": "Összes törlése",
        "save": "Mentés",
        "discard": "Elvetés",
        "showMore": "Még {{count}} megjelenítése",
        "showLess": "Kevesebb megjelenítése",
        "back": "Vissza",
        "next": "Következő",
        "previous": "Előző",
        "continue": "Folytatás",
        "yes": "Igen",
        "no": "Nem",
        "on": "Be",
        "off": "Ki",
        "none": "Nincs",
        "add": "Hozzáadás",
        "edit": "Szerkesztés",
        "delete": "Törlés",
        "more": "Több",
        "cardView": "Kártya nézet",
        "tableView": "Táblázat nézet",
        "required": "Kötelező",
        "loading": "Betöltés",
        "all": "Összes",
        "mustBeGreaterThanZero": "Nagyobbnak kell lennie, mint nulla",
        "freesoloAutocompletePlaceholder": "Nyomj entert az új érték hozzáadásához",
        "requiredFieldsAreNotFilled": "Kötelező mezők nincsenek kitöltve",
        "translations": "Fordítások",
        "language": "Nyelv",
        "set": "Beállítás",
        "languageInfo": "A nyelvek elmentéséhez nem elég az itteni beállítás, kérlek használd a mentés gombot a külső elem esetén is.",
        "original": "Eredeti",
        "invalidUrl": "Érvénytelen URL",
        "name": "Név",
        "total": "Összesen",
        "enabled": "Engedélyezve",
        "disabled": "Letiltva",
        "changed": "módosítva",
        "rollback": "Visszafizetés",
        "cancelReservation": "Foglalás lemondása",
        "refundReservation": "Foglalás visszafizetése",
        "positiveNumber": "Pozitív számnak kell lennie",
        "pay": "Fizetés",
        "payWith": "Fizetés ezzel:",
        "remaining": "Fennmaradó",
        "willPayInThisTransaction": "Ezzel a tranzakcióval fizetendő:",
        "import": "Import",
        "resend": "Újraküldés",
        "sending": "Küldés...",
        "errorLoadingData": "Hiba történt az adatok betöltésekor",
        "or": "Vagy",
        "url": "URL",
        "text": "Szöveg",
        "insert": "Beszúrás",
        "maxPercentage": "Nem lehet nagyobb, mint 100",
        "remove": "Eltávolítás",
        "removed": "Eltávolítva",
        "startTypingToSearch": "Kezdj el gépelni a kereséshez...",
        "noResults": "Nincs találat",
        "recentPaymentMethods": "Legutóbbiak",
        "searchOrSelectPaymentMethod": "Fizetési mód keresése vagy kiválasztása",
        "export": "Export",
        "error_loading_data": "Hiba történt az adatok betöltésekor",
        "translated": "Sikeres fordítás",
        "translationError": "A fordítás sikertelen",
        "translationNotNeeded": "A fordítás nem szükséges - a nyelvek megegyeznek",
        "autoTranslate": "Automatikus fordítás",
        "expandNotes": "Megjegyzések kibontása",
        "placeholder": "Helykitöltő",
        "manage": "Kezelés",
        "apply": "Alkalmaz",
        "rebooked": "Átfoglalva",
        "allTimesIn": "Minden idő {{timezone}} időzónában",
        "copiedToClipboard": "Vágólapra másolva",
        "create": "Létrehozás",
        "error": "Hiba",
        "formHasErrors": "Mentés előtt javítsa ki a hibákat ({{count}})",
        "invalidEmail": "Érvénytelen e-mail cím",
        "loadError": "Az adatok betöltése sikertelen",
        "refund": "Visszatérítés",
        "option": "Lehetőség"
    },
    "confirmationModal": {
        "title": "Biztos benne?",
        "content": "Ez a művelet nem vonható vissza."
    },
    "waitlist": {
        "pageTitle": "Várólista feliratkozások",
        "columns": {
            "subscriberDetails": "Feliratkozó adatai",
            "timeslot": "Időpont",
            "requested": "Igényelt",
            "fulfillability": "Teljesíthetőség",
            "activity": "Aktivitás",
            "actions": "Műveletek"
        },
        "labels": {
            "ticketsTotal": "Összesen {{count}} jegy",
            "noPhone": "Nincs telefonszám"
        },
        "status": {
            "ready": "Elérhető",
            "notEnoughSeats": "Nincs elég férőhely",
            "neverNotified": "Még nem értesítve"
        },
        "activity": {
            "added": "Hozzáadva: {{-date}}",
            "lastNotified": "Utoljára értesítve: {{-date}}",
            "sentTimes": "Elküldve: {{count}} alkalommal"
        },
        "actions": {
            "reminder": "Emlékeztető",
            "sendBulkReminder": "Tömeges emlékeztető küldése",
            "deleteConfirm": "Törlöd ezt a várólista-feliratkozást?",
            "convertToBooking": "Foglalássá alakítás",
            "convertConfirm": "Átalakítja ezt a várólistás bejegyzést foglalássá? Az ülőhelyek automatikusan ki lesznek osztva, és fizetési e-mail lesz küldve a vendégnek."
        },
        "filters": {
            "show": "Előadás",
            "timeslot": "Időpont",
            "allTimeslots": "Összes időpont",
            "search": "Keresés",
            "searchPlaceholder": "Keresés e-mail vagy név alapján...",
            "fulfillableOnly": "Csak teljesíthető",
            "neverNotifiedOnly": "Csak még nem értesített"
        },
        "empty": "Nincs még várólista-feliratkozás.",
        "emptyFiltered": "A kiválasztott szűrőkkel nem található várólista-feliratkozás.",
        "selectShow": "Válassz előadást a fenti szűrőből a várólista megtekintéséhez.",
        "selectShowAndTimeslot": "Válassz előadást és időpontot a fenti szűrőkből a várólista megtekintéséhez.",
        "sendingReminders": "Emlékeztetők küldése...",
        "notify": {
            "reminderSent": "Emlékeztető elküldve.",
            "notFulfillable": "A feliratkozás jelenleg nem teljesíthető.",
            "notFound": "A feliratkozás nem található.",
            "failedReminder": "Nem sikerült elküldeni az emlékeztetőt.",
            "deleted": "Feliratkozás törölve.",
            "bulkSent": "{{count}} emlékeztető elküldve.",
            "bulkSkipped": "Kihagyva: {{count}}",
            "bulkNotFound": "Nem található: {{count}}",
            "bulkFailed": "Sikertelen: {{count}}",
            "convertSuccess": "Foglalás létrehozva. Átirányítás a foglalás oldalára..."
        }
    },
    "paymentModal": {
        "title": "Fizetés",
        "content": "Kérjük, válassza ki a kívánt fizetési módot a folytatáshoz."
    },
    "login": {
        "title": "Bejelentkezés",
        "email": "Email",
        "password": "Jelszó",
        "login": "Bejelentkezés",
        "forgotPassword": "Elfelejtett jelszó?",
        "forgotPasswordTitle": "Elfelejtetted a jelszavad?",
        "forgotPasswordButton": "Jelszó visszaállító e-mail kérése",
        "passwordModified": "Jelszó sikeresen módosítva.",
        "passwordRequirements": {
            "length": "A jelszónak legalább 6 karakter hosszúnak kell lennie",
            "number": "A jelszónak tartalmaznia kell számot",
            "lowercase": "A jelszónak tartalmaznia kell kisbetűt",
            "uppercase": "A jelszónak tartalmaznia kell nagybetűt",
            "twoPasswordsMatch": "A jelszavaknak egyezniük kell"
        },
        "wrongEmailFormat": "Helytelen e-mail cím formátum",
        "newPasswordTitle": "Új jelszó megadása",
        "newPassword": "Új jelszó",
        "confirmPassword": "Jelszó megerősítése",
        "resetPassword": "Jelszó visszaállítása",
        "resetRequest": "Jelszó visszaállító kérelem",
        "forgotPasswordNotifySuccess": "Ha az e-mail cím regisztrálva van, akkor egy jelszó visszaállító e-mailt fog kapni.",
        "tiki": {
            "twoFactorTitle": "A Szent Kód",
            "twoFactorDescription": "A tűzszellemek bizonyítékot követelnek. Írd be a 6 jegyű kódot a totemből.",
            "twoFactorLabel": "Fáklya Token",
            "twoFactorSubmit": "Gyújtsd meg a Fáklyát",
            "twoFactorLoading": "A lángok olvasása...",
            "twoFactorError": "A szellemek elutasították a kódod. Próbáld újra, harcos."
        }
    },
    "auditlogs": {
        "title": "Audit logs",
        "eventCount": "{{count}} esemény",
        "unknownLogType": "Ismeretlen napló típus",
        "columns": {
            "venueName": "Helyszín neve",
            "userName": "Felhasználó neve",
            "logType": "Napló típus",
            "created": "Létrehozva",
            "logData": "Napló adatok"
        },
        "expandForDetailed": "Kibontás részletes verzióhoz.",
        "closeForBriefVersion": "Bezárás rövid verzióhoz."
    },
    "capabilities": {
        "title": "Alapértelmezett jogosultságok",
        "sectionTitle": "Jogosultságok",
        "custom": "Egyedi",
        "resetToDefaults": "Visszaállítás alapértelmezettre",
        "templateDescription": "Válassz egy sablont a jogosultságok gyors beállításához, vagy szabd testre egyenként alább.",
        "templates": "Gyors sablonok",
        "templatesSubtitle": "Kattints egy sablonra az előre beállított jogosultságokhoz, majd szabd testre.",
        "templateActive": "Aktív",
        "roleCapabilities": "{{role}} jogosultságok",
        "panelSubtitle": "Hozzáférés szintjeinek és jogosultságok beállítása ehhez a szerephez.",
        "status": "Állapot",
        "statusCustomized": "Egyedi",
        "missingDependency": "Szükséges: {{deps}}",
        "groups": {
            "venues": "Helyszínek",
            "shows": "Előadások",
            "bookings": "Foglalások",
            "operations": "Műveletek",
            "users": "Felhasználók",
            "payment_methods": "Fizetési módok",
            "coupons": "Kuponok",
            "integrations": "Integrációk",
            "commission_groups": "Jutalékcsoportok",
            "reports_invoices": "Riportok és számlák",
            "invoices": "Számlák",
            "logs": "Naplók",
            "reports": "Riport hozzáférés",
            "payments": "Fizetések",
            "system": "Rendszer"
        },
        "groupsSubtitles": {
            "venues": "Lista és részletek",
            "shows": "Eseménykezelés",
            "bookings": "Foglalási folyamatok",
            "operations": "Kiszolgálás és belépés",
            "users": "Csapatkezelés",
            "payment_methods": "Kártyafeldolgozás",
            "coupons": "Kuponok",
            "integrations": "Harmadik féltől származó kapcsolatok",
            "commission_groups": "Ügynöki jutalékok",
            "reports_invoices": "Pénzügyi adatok",
            "invoices": "Számlakezelés",
            "logs": "Audit és e-mail naplók",
            "reports": "Riportonkénti hozzáférés",
            "payments": "Fizetési felülírások",
            "system": "Globális beállítások"
        },
        "groupPermissionsSubtitle": {
            "bookings": "Hozzáférés a foglalások létrehozásához, módosításához és visszatérítéséhez.",
            "venues": "Helyszínbeállítások megtekintése és kezelése.",
            "shows": "Hozzáférés az előadás- és eseménykezeléshez.",
            "operations": "Hozzáférés a kiszolgálási és belépési nézetekhez.",
            "users": "Csapat tagok és szerepkörök kezelése.",
            "payment_methods": "Fizetési módok konfigurálása.",
            "coupons": "Kuponok létrehozása és kezelése.",
            "integrations": "Külső integrációk konfigurálása.",
            "commission_groups": "Ügynöki jutalékok kezelése.",
            "reports_invoices": "Hozzáférés a pénzügyi riportokhoz és számlákhoz.",
            "invoices": "Hozzáférés a számla riportokhoz.",
            "logs": "Audit és e-mail naplók megtekintése.",
            "reports": "Egyedi riporttípusokhoz való hozzáférés szabályozása.",
            "system": "Rendszerszintű adminisztráció."
        },
        "userSectionSubtitle": "Hozzáférési jogok és jogosultságok kezelése ehhez a felhasználóhoz.",
        "superadminBypass": "A szuperadmin felhasználók teljes hozzáféréssel rendelkeznek minden funkcióhoz, a jogosultságok beállítástól függetlenül. Nincs szükség konfigurációra.",
        "permissions": "Jogosultságok",
        "enabled": "engedélyezve",
        "saveChanges": "Módosítások mentése",
        "caps": {
            "venues_view": {
                "label": "Helyszínek megtekintése",
                "description": "Helyszínlista és részletek megtekintése"
            },
            "venues_manage": {
                "label": "Helyszínek kezelése",
                "description": "Helyszínek létrehozása, szerkesztése és törlése"
            },
            "shows_view": {
                "label": "Előadások megtekintése",
                "description": "Előadáslista és részletek megtekintése"
            },
            "shows_manage": {
                "label": "Előadások kezelése",
                "description": "Előadások létrehozása, szerkesztése és törlése"
            },
            "timeslots_view_hidden": {
                "label": "Rejtett idősávok megtekintése",
                "description": "A widgetből, integrációkból és jutalékcsoportokból elrejtett idősávok megtekintése és foglalása. Csak belső ügynököknek és adminoknak."
            },
            "bookings_view": {
                "label": "Foglalások megtekintése",
                "description": "Foglaláslista és részletek megtekintése"
            },
            "bookings_manage": {
                "label": "Foglalások kezelése",
                "description": "Foglalások létrehozása és szerkesztése"
            },
            "bookings_refund": {
                "label": "Foglalások visszatérítése",
                "description": "Foglalások visszatérítésének feldolgozása"
            },
            "bookings_import": {
                "label": "Foglalások importálása",
                "description": "Foglalások tömeges importálása"
            },
            "bookings_scope_all": {
                "label": "Összes foglalás megtekintése",
                "description": "Más ügynökök foglalásainak megtekintése (enélkül csak a sajátok láthatók)"
            },
            "catering_view": {
                "label": "Catering nézet",
                "description": "Hozzáférés a catering nézethez"
            },
            "checkin_view": {
                "label": "Bejelentkezési nézet",
                "description": "Hozzáférés a bejelentkezési nézethez"
            },
            "checkin_finish": {
                "label": "Check-in befejezése",
                "description": "Check-in lezárása és újranyitása egy időponthoz"
            },
            "users_manage": {
                "label": "Felhasználók kezelése",
                "description": "Felhasználók létrehozása, szerkesztése és törlése"
            },
            "payment_methods_view": {
                "label": "Fizetési módok megtekintése",
                "description": "Fizetési módok megtekintése"
            },
            "payment_methods_manage": {
                "label": "Fizetési módok kezelése",
                "description": "Fizetési módok létrehozása, szerkesztése és törlése"
            },
            "coupons_view": {
                "label": "Kuponok megtekintése",
                "description": "Kuponlista és részletek megtekintése"
            },
            "coupons_manage": {
                "label": "Kuponok kezelése",
                "description": "Kuponok létrehozása és törlése"
            },
            "integrations_manage": {
                "label": "Integrációk kezelése",
                "description": "Integrációk konfigurálása"
            },
            "commission_groups_view": {
                "label": "Jutalékcsoportok megtekintése",
                "description": "Jutalékcsoportok megtekintése"
            },
            "commission_groups_manage": {
                "label": "Jutalékcsoportok kezelése",
                "description": "Jutalékcsoportok létrehozása, szerkesztése és törlése"
            },
            "waitlist_manage": {
                "label": "Várakozó lista kezelése",
                "description": "Várakozó lista kezelése"
            },
            "upgrade_manage": {
                "label": "Upgrade-ek kezelése",
                "description": "Upgrade útvonalak kezelése és ajánlatok küldése"
            },
            "reports_view": {
                "label": "Riportok megtekintése",
                "description": "Eladási és egyéb riportok megtekintése"
            },
            "invoices_view": {
                "label": "Számlák megtekintése",
                "description": "Számla riportok megtekintése"
            },
            "logs_view": {
                "label": "Naplók megtekintése",
                "description": "Audit és e-mail naplók megtekintése"
            },
            "reports_sales_view": {
                "label": "Értékesítési riport megtekintése",
                "description": "Hozzáférés az értékesítési riporthoz"
            },
            "reports_sales_export": {
                "label": "Értékesítési riport exportálása",
                "description": "Az értékesítési riport letöltése fájlként"
            },
            "reports_transactions_view": {
                "label": "Tranzakciós riport megtekintése",
                "description": "Hozzáférés a tranzakciós riporthoz"
            },
            "reports_transactions_export": {
                "label": "Tranzakciós riport exportálása",
                "description": "A tranzakciós riport letöltése fájlként"
            },
            "reports_manifest_view": {
                "label": "Manifest riport megtekintése",
                "description": "Hozzáférés a manifest riporthoz"
            },
            "reports_manifest_export": {
                "label": "Manifest riport exportálása",
                "description": "A manifest riport letöltése fájlként"
            },
            "reports_commission_view": {
                "label": "Jutalék riport megtekintése",
                "description": "Hozzáférés a jutalék riporthoz"
            },
            "reports_commission_export": {
                "label": "Jutalék riport exportálása",
                "description": "A jutalék riport letöltése fájlként"
            },
            "reports_affiliate_sales_view": {
                "label": "Affiliate értékesítési riport megtekintése",
                "description": "Hozzáférés az affiliate értékesítési riporthoz"
            },
            "reports_affiliate_sales_export": {
                "label": "Affiliate értékesítési riport exportálása",
                "description": "Az affiliate értékesítési riport letöltése fájlként"
            },
            "reports_affiliate_invoice_view": {
                "label": "Affiliate számla riport megtekintése",
                "description": "Hozzáférés az affiliate számla riporthoz"
            },
            "reports_affiliate_invoice_export": {
                "label": "Affiliate számla riport exportálása",
                "description": "Az affiliate számla riport letöltése fájlként"
            },
            "reports_payout_view": {
                "label": "Kifizetési riport megtekintése",
                "description": "Hozzáférés a kifizetési riporthoz"
            },
            "reports_payout_export": {
                "label": "Kifizetési riport exportálása",
                "description": "A kifizetési riport letöltése fájlként"
            },
            "reports_booking_fee_view": {
                "label": "Foglalási díj riport megtekintése",
                "description": "Hozzáférés a foglalási díj riporthoz"
            },
            "reports_booking_fee_export": {
                "label": "Foglalási díj riport exportálása",
                "description": "A foglalási díj riport letöltése fájlként"
            },
            "reports_affiliate_cancelled_refunded_view": {
                "label": "Lemondott/visszatérített partneri riport megtekintése",
                "description": "Hozzáférés a lemondott és visszatérített partneri foglalások riportjához"
            },
            "reports_affiliate_cancelled_refunded_export": {
                "label": "Lemondott/visszatérített partneri riport exportálása",
                "description": "A lemondott/visszatérített partneri foglalások riportjának letöltése fájlként"
            },
            "seating_modify": {
                "label": "Foglalás helyének módosítása",
                "description": "Helykiosztás módosítása egyedi foglalásokon"
            },
            "seating_cross_ticket_type": {
                "label": "Eltérő jegytípusú helykiosztás",
                "description": "Helyek kiosztása eltérő jegytípushoz (vezetői felülírás)"
            },
            "seating_assignments": {
                "label": "Tömeges helykiosztás",
                "description": "Hozzáférés az időpont tömeges helykiosztási oldalához helyek kiosztásához és átmozgatásához"
            },
            "bookings_simplified_tickets": {
                "label": "Egyszerű foglalásszerkesztő",
                "description": "Zárolás egyszerűsített jegynézetre ültetési térkép és árszerkesztés nélkül"
            },
            "bookings_modify_past": {
                "label": "Múltbeli esemény foglalásainak módosítása",
                "description": "Foglalások szerkesztése (átütemezés, létszám módosítása, jegyek módosítása) az esemény kezdési ideje után"
            },
            "bookings_show_stats": {
                "label": "Foglalási statisztikák megtekintése",
                "description": "Foglalási statisztikák megtekintése"
            },
            "bookings_overbook": {
                "label": "Túlfoglalás",
                "description": "Foglalás létrehozásakor vagy módosításakor a férőhely- és lefoglalt-kapacitás-ellenőrzések megkerülése"
            },
            "bookings_cross_selling": {
                "label": "Cross-selling engedélyezése",
                "description": "Olyan foglalásmódosítás mentése, amely több jegytípust tartalmaz. Enélkül az ügynökök foglalásonként egy jegytípusra korlátozottak; az azonos típusú upgrade továbbra is engedélyezett."
            },
            "bookings_custom_rollback_times": {
                "label": "Egyéni visszagörgetési idők",
                "description": "Egyéni visszagörgetési időablakok beállítása foglalásokhoz. Lehetővé teszi az alapértelmezett lemondási/visszagörgetési határidők felülírását foglalásonként."
            },
            "bookings_always_refund": {
                "label": "Lemondási ablak felülírása visszatérítéssel",
                "description": "Lehetővé teszi a foglalás visszatérítéssel történő lemondását akkor is, ha a show lemondási ablaka már lejárt. A felhasználónak foglalásonként kifejezetten engedélyeznie kell — a felülírás nem alkalmazódik automatikusan. A számlázott foglalások mindenképpen zároltak maradnak."
            },
            "bookings_re_source": {
                "label": "Foglalás újraforrásozása",
                "description": "Foglalás újraforrásozása másik ügynökhöz, és tranzakció fizetési típusának váltása azonos díjú házon belüli fizetési módok között."
            },
            "bookings_cancel": {
                "label": "Foglalások törlése",
                "description": "Foglalások lemondása. E jogosultság nélkül a lemondás gomb rejtett és az API szinten is blokkolva van. Külső ügynököknek alapértelmezetten nincs meg ez a jogosultság."
            },
            "bookings_bypass_dynamic_pricing": {
                "label": "Dinamikus árazás megkerülése",
                "description": "Foglalás az eredeti (időpont szerinti/alapértelmezett) áron akkor is, ha a dinamikus árazás integráció be van kapcsolva. Alapértelmezetten csak adminoknak."
            },
            "payments_split_unlimited": {
                "label": "Korlátlan részletfizetés",
                "description": "Felülírja a helyszín részletfizetési limitjét. Lehetővé teszi a fizetés tetszőleges számú részletre osztását a helyszín beállításaitól függetlenül."
            }
        }
    },
    "venues": {
        "model": "Helyszín",
        "title": "Helyszínek",
        "singleTitle": "Helyszín",
        "columns": {
            "name": "Név",
            "site": "Helyszín",
            "availableLanguages": "Elérhető nyelvek",
            "allowedSplitPaymentAmount": "Max részletszám",
            "slug": "Slug",
            "tax": "Adó (%)",
            "invoiceRemitToName": "Számlán szereplő jogi entitás"
        },
        "allowedSplitPaymentAmountHelp": "Max részletszám a rendeléshez. 0 = korlátlan, 1 = nem osztható.",
        "invoiceRemitToNameHelp": "Az affiliate számlákon és kimutatásokon megjelenő jogi entitás neve. Üresen hagyva a helyszín neve jelenik meg.",
        "newVenueTitle": "Új helyszín",
        "importTitle": "Importálás a FareHarbor rendszerből",
        "importH2": "Importálás slug megadásával",
        "defaultName": "Új név",
        "defaultSlug": "újnév",
        "defaultSite": "Új helyszín",
        "isCurrent": "Aktív",
        "noVenues": "Nincs elérhető helyszín.",
        "notifications": {
            "added": "Helyszín sikeresen hozzáadva.",
            "updated": "Helyszín sikeresen frissítve.",
            "deleted": "Helyszín sikeresen törölve.",
            "deleteError": "Helyszín nem törölhető.",
            "importSuccess": "Helyszín adatai sikeresen importálva."
        }
    },
    "users": {
        "model": "Felhasználó",
        "title": "Felhasználók",
        "columns": {
            "name": "Név",
            "email": "Email",
            "role": "Szerepkör",
            "venueName": "Helyszín"
        },
        "roleLabels": {
            "superadmin": "Szuperadmin",
            "user": "Felhasználó",
            "admin": "Admin",
            "manager": "Menedzser",
            "agent": "Ügynök",
            "executive": "Vezető",
            "guest": "Vendég",
            "external_agent": "Külső ügynök",
            "accountant": "Könyvelő",
            "caterer": "Felszolgáló"
        },
        "venueSelect": "Helyszín",
        "newUserTitle": "Új felhasználó",
        "notifications": {
            "added": "Meghívó sikeresen elküldve és a felhasználó sikeresen hozzáadva a helyszínhez.",
            "updated": "Felhasználó sikeresen frissítve.",
            "deleted": "Felhasználó sikeresen törölve a helyszínről.",
            "deleteError": "Felhasználó nem törölhető.",
            "switchVenue": "Átváltva a helyszínre",
            "profileUpdated": "Felhasználói profil frissítve",
            "twoFactorReset": "Kétfaktoros hitelesítés sikeresen visszaállítva",
            "twoFactorDisabled": "Kétfaktoros hitelesítés sikeresen letiltva"
        },
        "switchToVenue": "Helyszín váltás",
        "myProfile": "Saját profilom",
        "tabs": {
            "profileDetails": "Profil adatai",
            "capabilitiesPermissions": "Jogosultságok",
            "securityAccess": "Biztonság és hozzáférés"
        },
        "switchVenueDescription": "A névre Kattintással átválthatsz egy másik helyszínre.",
        "noVenues": "Nincs elérhető helyszín.",
        "userDetails": "Felhasználói adatok",
        "myDetails": "Saját adataim",
        "security": "Biztonság",
        "enableTwoFactor": "Kétfaktoros hitelesítés engedélyezése",
        "enableTwoFactorPlaceholderDescription": "Szkennelje be az alábbi QR-kódot a hitelesítő alkalmazásával (Google Authenticator, Authy, stb.).",
        "enterTwoFactorCode": "Adja meg az alkalmazásban megjelenő 6 jegyű kódot:",
        "twoFactorVerification": "Kétfaktoros hitelesítés",
        "enterTwoFactorCodeDescription": "Kérjük, adja meg a hitelesítő alkalmazásában megjelenő 6 jegyű kódot a folytatáshoz.",
        "invalidTwoFactorCode": "Érvénytelen 2FA kód. Kérjük, próbálja újra.",
        "twoFactorEnabled": "Kétfaktoros hitelesítés sikeresen engedélyezve!",
        "disableTwoFactor": "Kétfaktoros hitelesítés letiltása",
        "disableTwoFactorConfirm": "Biztosan ki szeretné kapcsolni a kétfaktoros hitelesítést? Fiókja kevésbé lesz biztonságos.",
        "resetTwoFactor": {
            "title": "Kétfaktoros hitelesítés visszaállítása",
            "subtitle": "Itt visszaállíthatja a felhasználó kétfaktoros hitelesítését.",
            "forceResetTitle": "2FA visszaállítása",
            "forceResetDescription": "Ez kikapcsolja a 2FA-t a felhasználó számára, amíg újra be nem állítja.",
            "button": "2FA visszaállítása"
        },
        "passwordOverride": {
            "title": "Jelszó felülírás",
            "warning": "Ez azonnal felülírja a felhasználó bejelentkezési jelszavát.",
            "generatedPassword": "Generált jelszó",
            "setRandomButton": "Random jelszó beállítása",
            "copyButton": "Jelszó másolása",
            "copyShort": "Másolás",
            "subtitle": "Frissítsd a felhasználó bejelentkezési adatait.",
            "statusActive": "Aktív",
            "warningTitle": "Jelszó felülírás figyelmeztetés",
            "forceResetTitle": "Jelszó kényszerített visszaállítása",
            "forceResetDescription": "Azonnal visszaállítja a felhasználó jelszavát egy biztonságos, szerveroldali titokra.",
            "generateNewButton": "Új jelszó generálása",
            "successInfo": "A jelszó sikeresen generálva. Kérjük, másold ki most.",
            "lastChangedNone": "Utolsó módosítás: -",
            "lastChangedBy": "Utolsó módosítás: {{date}} által: {{name}}",
            "lastChangedByForgottenPassword": "Utolsó módosítás: {{date}} által: {{name}} (Elfelejtett jelszó folyamat)",
            "confirmTitle": "Jelszó felülírás megerősítése",
            "confirmRandom": "Biztosan generálsz és beállítasz egy random jelszót a felhasználónak?",
            "notifications": {
                "randomSet": "A jelszó visszaállítása sikeresen megtörtént.",
                "randomSetCopied": "A jelszó visszaállítása megtörtént, és a vágólapra másoltuk.",
                "copied": "A jelszó vágólapra másolva."
            }
        }
    },
    "shows": {
        "model": "Műsor",
        "title": "Műsorok",
        "columns": {
            "title": "Cím",
            "subtitle": "Alcím",
            "description": "Leírás",
            "cancelWindow": "Lemondási időszak (óra)",
            "cancelDescription": "Lemondási tudnivalók",
            "needToKnow": "Fontos tudnivalók",
            "location": "Helyszín",
            "countryCode": "Országkód",
            "destinationCode": "Úticél kód (Város/Helyszín)",
            "destinationCodeHelper": "Kérlek válassz országkódot az úticél kód megadásához",
            "venueName": "Helyszín neve",
            "enabledAbandonedCartEmail": "Elhagyott kosár e-mail engedélyezése",
            "guestCancellationEnabled": "Vendég önálló lemondás engedélyezése",
            "reservationTime": "Foglalási idő (perc)",
            "reviewText": "Értékelési szöveg",
            "reviewLink": "Értékelési link (SMS)",
            "tripadvisorUrl": "Tripadvisor URL",
            "timeslotManagement": "Idősáv kezelés",
            "iCalUrl": "iCal URL",
            "autoPublishDaysInAdvance": "Automatikus közzététel napokban",
            "rollbackTimeSize": "Visszafizetési idő (perc)",
            "rollbackTimeSizeHelp": "= {{hours}} ó {{minutes}} p",
            "bookingWindow": "Foglalási ablak (óra)",
            "bookingWindowHelp": "Vendégek nem foglalhatnak az előadás kezdete előtt {{hours}} órán belül",
            "marketing": {
                "logo": "Logó",
                "primaryImage": "Elsődleges kép",
                "extraImages": "További képek",
                "subheadline": "Alcím",
                "tags": "Címkék",
                "duration": "Hossz (óra)",
                "location": "Helyszín",
                "email": "Email",
                "phone": "Telefon",
                "tracking": {
                    "ga4": "Google Analytics 4 ID",
                    "facebook": "Facebook Pixel ID",
                    "tiktok": "TikTok Pixel ID",
                    "linkedin": "LinkedIn Partner ID",
                    "twitter": "Twitter Pixel ID",
                    "snapchat": "Snapchat Pixel ID",
                    "pinterest": "Pinterest Tag ID"
                }
            },
            "senderEmailPrefix": "Feladó e-mail cím",
            "senderEmailPrefixHelper": "A show-hoz kapcsolódó e-mailek feladója. Alapértelmezés: no-reply.",
            "delayedSeatAssignmentEnabled": "Ülésszelekció letiltása (widget + automatikus helykiosztás az adminban)",
            "allowCrossTicketBuying": "Több jegytípus vásárlásának engedélyezése egy tranzakcióban",
            "absorbProcessingFee": "Tranzakciós díj átvállalása (a helyszín fizeti)",
            "allowSeatingGroupRequest": "Vendégek kérhessék, hogy barátaikkal ülhessenek",
            "rentalMode": "Bérlési mód (kabin / napágy bérlés testreszabható sávokkal)",
            "slotTemplateTitle": "Bérlési sávok",
            "slotTemplateHint": "Add meg a bérlési naponként kínált sávokat. Minden sávból egy idősáv lesz; az átfedő idejű sávok ülései ütköznek.",
            "slotTemplateRentalOffHint": "Kapcsold be a bérlési módot a sávok beállításához.",
            "slotTemplateAdd": "Sáv hozzáadása",
            "slotTemplateLabel": "Megnevezés",
            "slotTemplateStartTime": "Kezdés",
            "slotTemplateDuration": "Időtartam (perc)",
            "slotTemplateIsFullDay": "Egész napos sáv",
            "slotTemplateRemove": "Sáv törlése",
            "slotTemplateMoveUp": "Mozgatás fel",
            "slotTemplateMoveDown": "Mozgatás le",
            "slotTemplateDuplicateKey": "A sáv megnevezéseknek egyedinek kell lenniük",
            "requireAdultTicket": "A kosárban legalább egy felnőtt jegy szükséges (gyerek/csecsemő önállóan nem foglalhat)",
            "delayedSeatAssignmentUseSeatIdsInEmails": "Ülésazonosítók az e-mailekben (ellenkező esetben csak asztalazonosítók)",
            "isBreakingOutFees": "Költségek és adók lebontása",
            "priceListingMode": "Jegyár megjelenítés",
            "fees": "Illetékek",
            "feesAttributes": {
                "name": "Név",
                "percentage": "Százalék",
                "usd": "USD összeg",
                "isTax": "Adó",
                "onlineOnly": "Csak online"
            },
            "waitlistNotificationEmailsLabel": "Várólista értesítési e-mail címek",
            "waitlistNotificationEmailsHelp": "Az itt megadott címek e-mailt kapnak, ha egy várólistás jelentkezés teljesíthetővé válik ezen az előadáson.",
            "waitlistNotificationEmailsInvalid": "Kérjük, adjon meg egy érvényes e-mail címet",
            "checkinNotificationEmailsLabel": "Check-in értesítési e-mail címek",
            "checkinNotificationEmailsHelp": "Az itt megadott címek értesítést kapnak az előadás check-in eseményeiről.",
            "checkinNotificationEmailsInvalid": "Kérjük, adjon meg egy érvényes e-mail címet",
            "bookingFeeRebateShare": "Foglalási díj helyszín visszatérítés",
            "bookingFeeRebateShareHelp": "A műsor foglalási díjának a helyszínnek visszatérített aránya (pl. 30). Üresen hagyva nincs.",
            "upgradeNotificationEmailsLabel": "Frissítési értesítési e-mailek",
            "upgradeNotificationEmailsHelp": "Vesszővel elválasztott e-mail-címek, amelyek értesítést kapnak, amikor foglalások frissítésre jogosulttá válnak.",
            "upgradeNotificationEmailsInvalid": "Érvénytelen e-mail a frissítési értesítési listában",
            "cancellationReasonsTitle": "Előre beállított lemondási okok",
            "cancellationReasonTitle": "Cím",
            "cancellationReasonSubtext": "Leírás",
            "cancellationReasonColor": "Lemondott idősáv színe",
            "cancellationReasonColorReset": "Visszaállítás az alapértelmezett színre"
        },
        "timeslotManagementValues": {
            "iCalSync": "iCal szinkronizálás",
            "manual": "Manuális idősáv kezelés"
        },
        "feeDisplayModes": {
            "noBreakdown": "Nincs bontás (csak végösszeg)",
            "simpleBreakdown": "Egyszerű bontás (adók és díjak együtt)",
            "detailedBreakdown": "Részletes bontás (tételenkénti)"
        },
        "priceListingModes": {
            "gross": "Bruttó (az ár tartalmazza az adókat és díjakat)",
            "net": "Nettó (az ár nem tartalmazza az adókat és díjakat; az oldalsávon foglalási díj + feldolgozási díj jelenik meg)"
        },
        "cancelableAnyTime": "Bármikor lemondható",
        "cancelUnit": "óra",
        "newShowTitle": "Új műsor",
        "defaultTitle": "Új cím",
        "defaultDescription": "Új leírás",
        "notifications": {
            "added": "Műsor sikeresen hozzáadva.",
            "updated": "Műsor sikeresen frissítve.",
            "deleted": "Műsor sikeresen törölve.",
            "deleteError": "Műsor nem törölhető."
        },
        "validation": {
            "reservationTimeMin": "A foglalási idő nem lehet kevesebb, mint 5",
            "rollbackTimeSize": "A visszafizetési idő nem lehet kevesebb, mint 5 perc"
        },
        "marketingTitle": "Marketing",
        "bookingBehaviorGroup": "Foglalási viselkedés",
        "notificationsGroup": "Értesítések",
        "pricingDisplayGroup": "Árak megjelenítése",
        "contactVenue": "Helyszín kapcsolattartó",
        "mainInfoTitle": "Fő információk",
        "detailsTitle": "Műsor részletei",
        "otherInfoTitle": "Egyéb információk",
        "settingsTitle": "Beállítások",
        "settingsTabs": {
            "general": "Általános",
            "bookingRules": "Foglalási szabályok",
            "content": "Tartalom és szabályzat",
            "notifications": "Értesítések",
            "pricing": "Árazás"
        },
        "feesTitle": "Illetékek",
        "trackingTitle": "Analitika és Követés",
        "trackingDescription": "Állítsd be a marketing platform követési azonosítóit ehhez a műsorhoz. Hagyd üresen a mezőket, ha nem használod az adott platformot.",
        "stylingTabTitle": "Stílus",
        "stylingTitle": "Widget stílus",
        "stylingDescription": "Állítsd be a widget színeit ehhez a műsorhoz. Hagyj egy mezőt üresen, hogy az alapértelmezett értéket használja. Az értékeknek hex színeknek kell lenniük (pl. #ff0033).",
        "stylingResetAll": "Összes visszaállítása",
        "stylingInvalidHex": "Használj hex színt, pl. #ff0033",
        "stylingFields": {
            "primary": "Elsődleges szín",
            "primary-bg": "Elsődleges gomb háttér",
            "primary-bg-active": "Elsődleges gomb háttér (lenyomva)",
            "primary-bg-hover-and-focus": "Elsődleges gomb háttér (hover/fókusz)",
            "primary-color": "Elsődleges gomb szövege",
            "secondary": "Másodlagos szín",
            "featured-card-bg": "Kiemelt kártya háttér",
            "featured-card-color": "Kiemelt kártya szöveg",
            "header-color": "Fejléc szín",
            "default-color": "Szövegszín",
            "default-bg": "Háttérszín"
        },
        "stylingBasicsTitle": "Alapok",
        "stylingAdvancedTitle": "Speciális szín-felülírások",
        "stylingFontsTitle": "Betűtípusok",
        "stylingFontsDescription": "Válassz a listából, vagy írj be bármilyen Google Fonts család nevet (pl. „Crimson Text\", „JetBrains Mono\"), majd nyomj Entert. A widget futásidőben tölti be a betűtípust a Google Fontsról. Az Inter helyileg van csomagolva. Ismeretlen nevek esetén csendben visszaesik az alapértelmezettre.",
        "stylingFontHeader": "Fejléc betűtípus",
        "stylingFontBody": "Szöveg betűtípus",
        "stylingNightMode": "Sötét mód",
        "stylingNightModeAuto": "Rendszer szerint",
        "stylingNightModeLight": "Mindig világos",
        "stylingNightModeDark": "Mindig sötét",
        "stylingSurpriseMe": "Lepj meg",
        "feesInfo": "Ezek a díjak minden foglalásra vonatkoznak erre a műsorra. Lehetnek a teljes foglalási összeg százalékos arányai vagy egy fix USD összeg. Például hozzáadhatsz egy 5%-os szolgáltatási díjat és egy 2,00 USD feldolgozási díjat. Ezek a díjak külön jelennek meg a pénztárnál.",
        "feesValidation": "Minden díj esetében meg kell adni a százalékos arányt vagy az USD összeget, és ezeknek nagyobbnak kell lenniük nullánál.",
        "noShows": "Nem található műsor",
        "actionGroups": {
            "tickets": "Jegyek",
            "scheduling": "Időpontok és kedvezmények",
            "system": "Rendszer",
            "manage": "Kezelés",
            "commissionGroups": "Jutalékcsoportok"
        },
        "verification": {
            "tabTitle": "Ellenőrzés",
            "title": "Kosár-ellenőrző szkript",
            "description": "Opcionális JavaScript kifejezés, amely minden kosárváltozáskor a szerveren fut. Használja foglalási szabályok kikényszerítésére (pl. „ölbe vehető gyermek nem vásárolható önállóan\") vagy a végösszeg feltételes módosítására.",
            "helpHeader": "A szkript egy `input` objektumot kap, amely tartalmazza a teljes kosarat, az összegeket, a kapcsolati adatokat, a kupont, a fizetési módot (ha már ki van választva) és a nyelvet. Vagy egy számot kell visszaadnia (eltérés centben, +/-), vagy egy numerikus `code` tulajdonsággal rendelkező Error-t kell dobnia a kosár elutasításához. A kódok az alábbi üzenetekhez vannak rendelve.",
            "helpExample": "if (input.cart.find(i => i.ticketOptionName === 'Lap child') && input.cart.length === 1) {\n  const e = new Error(); e.code = 801; throw e;\n}\nreturn 0;",
            "scriptLabel": "Ellenőrző szkript",
            "scriptPlaceholder": "// return 0; // nincs művelet",
            "messagesTitle": "Hibaüzenetek kódonként",
            "messagesDescription": "Amikor a szkript numerikus kóddal dob hibát, a vásárló nyelvének megfelelő üzenet jelenik meg. Minden támogatott nyelvhez adjon hozzá ugyanazt a kódot; az angol a tartalék.",
            "noMessages": "Még nincsenek hibaüzenetek megadva. Adjon hozzá egyet minden kódhoz, amelyet a szkriptje dobhat.",
            "codeLabel": "Kód",
            "messageLabel": "Üzenet",
            "addMessage": "Hibakód hozzáadása",
            "promptTitle": "Írja le a szabályt",
            "promptDescription": "Írja le egyszerű magyar nyelven, mit kell tennie a szabálynak. LLM segítségével szkripttel alakítjuk át. A prompt az előadással együtt elmentésre kerül, így később módosítható.",
            "promptLabel": "Prompt",
            "promptPlaceholder": "pl. Igényeljen legalább 2 parkolójegyet, ha bármilyen parkolójegy van a kosárban. Használja a 901-es hibakódot.",
            "generateButton": "Generálás promptból",
            "regenerateButton": "Újragenerálás promptból",
            "generating": "Generálás...",
            "generationSuccess": "Ellenőrző szkript generálva. A meglévő szkript lecserélve; az új hibaüzenetek a meglévőkkel összefésülve. Ellenőrizze a Speciális szekciót és mentse az előadást.",
            "generationBehaviorHint": "A generálás teljesen lecseréli a szkriptet; az új hibaüzenetek beolvasztásra kerülnek a meglévő listába (a meglévő kódok megmaradnak).",
            "advancedToggle": "Speciális (szkript és üzenetek)",
            "lockedChip": "Kézileg szerkesztett",
            "generatedChip": "Promptból generált",
            "lockedConfirmTitle": "Felülírja a kézi módosításokat?",
            "lockedConfirmBody": "Az aktuális szkriptet az utolsó generálás után kézileg szerkesztették. Az újragenerálás felülírja. Folytatja?",
            "helpPromptLabel": "A prompt, amelyből a szkript generálva lett",
            "helpInputLabel": "A szkriptnek átadott `input` szerkezete (az LLM is ezt kapja)",
            "translationsTitle": "Fordítások a {{code}} kódhoz",
            "translationsHint": "Szerkessze a nyelvenkénti üzeneteket, vagy kattintson a szikra ikonra az angol szöveg LLM-mel történő fordításához.",
            "translationsSourceLabel": "Angol üzenet (forrás)",
            "translationsNoLanguages": "Ez a helyszín csak angol nyelvet támogat. A fordítások engedélyezéséhez adjon hozzá több nyelvet a helyszínhez.",
            "translateButton": "Fordítás angolból",
            "translateMissingSource": "Írjon be egy angol üzenetet a fordítás előtt.",
            "formatScript": "Szkript formázása",
            "copyScript": "Szkript másolása",
            "copyAck": "Másolva!",
            "testRunTitle": "Tesztfuttatás (sandboxolt, böngészőben)",
            "testInputLabel": "Mintabemenet (JSON)",
            "testResultLabel": "Eredmény",
            "testReset": "Visszaállítás a mintára",
            "testRun": "Teszt futtatása",
            "testIdle": "Kattintson a „Teszt futtatása\" gombra a szkript futtatásához a mintabemeneten.",
            "testEmpty": "A szkript üres — előbb generálja vagy írja meg.",
            "testBadInput": "A mintabemenet nem érvényes JSON",
            "testReturned": "A szkript visszatért",
            "testThrown": "A szkript hibát dobott",
            "testThrownCode": "A szkript hibát dobott ({{code}} kóddal)",
            "testElapsed": "Futási idő: {{ms}}ms"
        },
        "addCancellationReason": "Ok hozzáadása"
    },
    "ticketoptions": {
        "model": "Jegy opció",
        "title": "Jegy opciók",
        "columns": {
            "name": "Név",
            "description": "Leírás",
            "showTitle": "Műsor címe",
            "ageBand": "Korosztály",
            "guestVisible": "Vendégek számára látható",
            "timeslotPeriod": "Bérlési sáv"
        },
        "timeslotPeriod": {
            "allPeriods": "Minden sáv"
        },
        "ageBand": {
            "notDefined": "Nincs megadva",
            "adult": "Felnőtt",
            "child": "Gyermek",
            "youth": "Ifjúsági",
            "infant": "Csecsemő",
            "senior": "Idős"
        },
        "newTicketOptionName": "Új jegy opció",
        "defaultName": "Új név",
        "defaultDescription": "Új leírás",
        "reorderMode": "Jegy opciók átrendezése",
        "notifications": {
            "added": "Jegy opció sikeresen hozzáadva.",
            "updated": "Jegy opció sikeresen frissítve.",
            "deleted": "Jegy opció sikeresen törölve.",
            "deleteError": "Jegy opció nem törölhető.",
            "reorderSaved": "Jegy opció sorrend elmentve.",
            "reorderError": "A jegy opciók sorrendjének mentése sikertelen."
        }
    },
    "tickettypes": {
        "model": "Jegy típus",
        "title": "Jegy típusok",
        "columns": {
            "name": "Név",
            "description": "Leírás",
            "showTitle": "Műsor címe",
            "showInList": "Megjelenítés a listában",
            "canBuyAlone": "Önállóan is megvásárolható",
            "priceMatrix": "Jegyárak",
            "guestVisible": "Vendég számára látható",
            "automaticSeating": "Automatikus ülésfoglalás",
            "customFields": "További kérdések",
            "ticketSeats": "Ülőhelyek",
            "blockLimit": "Blokk limit",
            "checkinTimeBeforeStart": "Bejelentkezés a kezdés előtt (perc)",
            "color": "Szín"
        },
        "automaticSeating": {
            "manual": "Manuális ülésfoglalás",
            "auto": "Javasolt ülésfoglalás",
            "fullauto": "Automatikus ülésfoglalás"
        },
        "customFieldsAttributes": {
            "type": "Típus",
            "name": "Név",
            "description": "Leírás",
            "required": "Kötelező",
            "showInCatering": "Megjelenítés vendéglátás nézetben"
        },
        "customFieldsTypes": {
            "singleLine": "Szöveg",
            "multiLine": "Többsoros szöveg",
            "dropdown": "Legördülő lista"
        },
        "addNewNote": "Új megjegyzés hozzáadása",
        "newNoteName": "Új megjegyzés neve",
        "newNoteDescription": "Új megjegyzés leírása",
        "removeNote": "Megjegyzés eltávolítása",
        "additionalInformation": "További információk",
        "requiredFieldsEmpty": "Kitöltetlen kötelező mezők: {{fields}}",
        "noFreeSeatsAvailable": "Nincs szabad ülőhely",
        "freeTicketSeatNumber": "Szabad ülőhelyek száma",
        "newTicketTypeName": "Új jegy típus",
        "defaultName": "Új név",
        "defaultDescription": "Új leírás",
        "reorderMode": "Jegy típusok átrendezése",
        "notifications": {
            "added": "Jegy típus sikeresen hozzáadva.",
            "updated": "Jegy típus sikeresen frissítve.",
            "deleted": "Jegy típus sikeresen törölve.",
            "deleteError": "Jegy típus nem törölhető.",
            "reorderSaved": "Jegy típus sorrend elmentve.",
            "reorderError": "A jegy típusok sorrendjének mentése sikertelen."
        },
        "priceMatrixValueNameLabel": "Név",
        "priceMatrixValuePriceLabel": "Ár",
        "noPriceMatrix": "Nincs ár mátrix",
        "noCustomFields": "Nincsenek további információk",
        "priceMatrixWarning": "Kérlek ellenőrizd, hogy a megfelelő jegy nevek és árak szerepelnek-e az ár mátrixban. Az ár mátrixban szereplő értékek csak a jegyvásárlás során jelennek meg.",
        "customFieldsInfo": "Az alábbi mezők megjelennek a jegyvásárlás során. Kérlek, add meg a mező nevét és típusát. A mezők beállíthatóak kötelező, vagy nem kötelező mezőként.",
        "wrongPriceCalculation": "Hibás árkalkuláció!",
        "improvedPriceMatrixInfo": "Adja meg az árakat minden jegyopcióhoz. Hagyja üresen az elérhetetlen kombinációkhoz (az üres mező azt jelenti, hogy nincs kombináció, még a 0 is érvényes ár).",
        "errorLoadingTicketOptions": "Hiba történt a jegyopciók betöltésekor ennél az előadásnál.",
        "noTicketOptionsAvailable": "Ehhez az előadáshoz nem állnak rendelkezésre jegyopciók. Kérjük, először adjon hozzá jegyopciókat.",
        "ticketOption": "Jegyopció",
        "price": "Ár",
        "noPrice": "Nincs ár",
        "ticketType": "Jegytípus",
        "listView": "Lista nézet",
        "matrixView": "Mátrix nézet",
        "priceMatrixViewInfo": "Kapcsolja be a szerkesztő módot az árak módosításához. Az üres mező azt jelenti, hogy nincs elérhető kombináció.",
        "priceMatrixEmptyState": "Kezdje az első jegytípus és jegyopció hozzáadásával az alábbiakban.",
        "noTicketTypesHint": "Addja hozzá az első jegytípust alább.",
        "noTicketOptionsHint": "Adja hozzá az első jegyopciót a fejléc sorban.",
        "matrixSaved": "Az ár mátrix sikeresen elmentve!",
        "errorLoadingData": "Hiba történt az adatok betöltésekor.",
        "noTicketTypes": "Ehhez az előadáshoz nem állnak rendelkezésre jegytípusok.",
        "noTicketOptions": "Ehhez az előadáshoz nem állnak rendelkezésre jegyopciók.",
        "noTimeslots": "Ehhez az előadáshoz nem állnak rendelkezésre időpontok.",
        "noBlockLimit": "Nincs limit",
        "blockLimitInfo": "Maximum számú jegy, amely eladható egy időpontban a vendégek számára. Hagyja üresen a korlátlanhoz.",
        "checkinTimeBeforeStartInfo": "Hány perccel az előadás kezdete előtt kell bejelentkezni ennél a jegytípusnál. A 0 azt jelenti, hogy a kezdési idővel egyezik.",
        "colorInfo": "Szín, amelyet a jegytípus ábrázolására használnak a helyszíni térképen. Hex színkódokat kell használni (pl. #FF5733).",
        "seatMapHintClick": "Kattints egy ülőhelyre a kijelöléshez.",
        "seatMapHintShift": "Tartsd lenyomva a Shift billentyűt és húzz egy területet több ülőhely kijelöléséhez."
    },
    "seats": {
        "model": "Ülőhely",
        "title": "Ülőhelyek",
        "importTitle": "Ülőhelyek importálása",
        "importSuccess": "Ülőhelyek sikeresen importálva.",
        "cloneTitle": "Ülőhelyek másolása",
        "cloneDescription": "Válassz egy helyszínt és egy műsort, ahova át szeretnéd másolni ezeket az ülőhelyeket.",
        "cloneSuccess": "Ülőhelyek sikeresen átmásolva.",
        "columns": {
            "id": "ID",
            "name": "Név",
            "x": "X",
            "y": "Y",
            "rotation": "Forgatás",
            "scale": "Méret",
            "bookable": "Foglalható",
            "model": "Modell"
        },
        "upload": {
            "uploadTitle": "Ülőhelyek feltöltése",
            "uploadFormats": "Támogatott formátum: XLSX"
        },
        "notifications": {
            "added": "Ülőhely sikeresen hozzáadva.",
            "updated": "Ülőhely sikeresen frissítve.",
            "deleted": "Ülőhely sikeresen törölve.",
            "deleteError": "Ülőhely nem törölhető.",
            "createError": "Ülőhely nem hozható létre.",
            "updateError": "Ülőhely nem frissíthető.",
            "exportSuccess": "Ülőhelyek sikeresen exportálva.",
            "arrangementAdded": "Elrendezés létrehozva",
            "arrangementDeleted": "Elrendezés törölve",
            "arrangementError": "Elrendezés frissítése sikertelen"
        },
        "import": {
            "toAdd": "Hozzáadandó székek",
            "toUpdate": "Módosítandó székek",
            "toDelete": "Törlendő székek",
            "errorsFound": "Hibák találhatók az importálandó adatokban. Kérjük, javítsa őket a mentés előtt.",
            "status": "Állapot",
            "changes": "Változások",
            "customModel": "Egyedi",
            "noChangesFound": "Nem találtunk végrehajtható változtatásokat."
        },
        "validation": {
            "xNumber": "Az X koordinátának számnak kell lennie",
            "yNumber": "Az Y koordinátának számnak kell lennie",
            "rotationNumber": "A forgatásnak számnak kell lennie",
            "rotationRange": "A forgatásnak -360 és 360 fok közé kell esnie",
            "invalidModel": "Érvénytelen modell: {{model}}",
            "bookableBoolean": "A foglalhatóságnak logikai értéknek (Igen/Nem) kell lennie",
            "idNotFound": "A szék rendelkezik azonosítóval, de nem található a jelenlegi előadásban; új szék lesz létrehozva.",
            "missingIdForDelete": "A törlendő szék azonosítója hiányzik."
        },
        "arrangements": "Elrendezések",
        "defaultArrangement": "Alapértelmezett",
        "addArrangement": "Elrendezés hozzáadása",
        "arrangementName": "Elrendezés neve",
        "activeArrangement": "Aktív ülésrend",
        "removeFromArrangement": "Eltávolítás az elrendezésből",
        "active": "Aktív",
        "deleteArrangementConfirm": "Biztosan törölni szeretnéd ezt az elrendezést? Ez a művelet nem visszavonható."
    },
    "timeslots": {
        "model": "Idősáv",
        "title": "Idősávok",
        "full": "Teli",
        "available": "Elérhető (>{{threshold}})",
        "limited": "Korlátozott (1-{{threshold}})",
        "soldOut": "Teli (0)",
        "columns": {
            "showTitle": "Műsor címe",
            "startTime": "Kezdési idő",
            "isReviewEmailSuppressed": "Visszajelzési e-mailek letiltása",
            "timeslotPeriod": "Bérlési sáv",
            "timeslotPeriodNone": "Nincs (normál esemény)",
            "timeslotGroupId": "Bérlési nap csoport ID",
            "timeslotGroupIdHint": "Az ugyanazon bérlési naphoz tartozó sáv-idősávokat kapcsolja össze. Normál idősávoknál hagyja üresen.",
            "isHidden": "Rejtett idősáv",
            "note": "Megjegyzés"
        },
        "isHiddenHelp": "Rejtve a widget, az integrációk és a jutalékcsoportok elől. Csak a \"Rejtett idősávok megtekintése\" jogosultsággal rendelkező felhasználók láthatják és foglalhatják.",
        "newTimeslotName": "Új idősáv",
        "bulkAddName": "Idősávok tömeges hozzáadása",
        "createRentalDay": "Bérlési nap létrehozása",
        "createRentalDayHint": "Létrehozza a beállított bérlési idősávokat a kiválasztott dátumra, és az átfedő idősávokat csoportosítja az ütközések felismeréséhez.",
        "editRentalDay": "Bérlési nap szerkesztése",
        "editRentalDayHint": "Módosítsd a bérlési nap dátumát és az idősávok időpontjait. Minden foglalás az idősávjával együtt mozog.",
        "bulkRentalDaysName": "Bérlési napok tömeges hozzáadása",
        "rentalDate": "Bérlési dátum",
        "changeTimeslot": "Idősáv változtatása",
        "bulkAdd": {
            "title": "Ismétlődő menetrend",
            "daysLabel": "A hét napjai",
            "timeLabel": "Időpont",
            "startDateLabel": "Kezdő dátum",
            "endDateLabel": "Záró dátum",
            "endAfterStart": "A záró dátumnak a kezdő dátummal egyenlőnek vagy annál későbbinek kell lennie",
            "preview": "{{count}} egyező dátum (a meglévő idősávok kimaradnak)",
            "preview_plural": "{{count}} egyező dátum (a meglévő idősávok kimaradnak)",
            "progressLabel": "{{completed}} / {{total}} feldolgozva ({{percent}}%)",
            "days": {
                "0": "Vas",
                "1": "Hét",
                "2": "Kedd",
                "3": "Szer",
                "4": "Csüt",
                "5": "Pén",
                "6": "Szom"
            }
        },
        "bulkRentalDays": {
            "preview": "{{count}} egyező dátum (a meglévő bérlési napok kimaradnak)",
            "preview_plural": "{{count}} egyező dátum (a meglévő bérlési napok kimaradnak)"
        },
        "notifications": {
            "added": "Idősáv sikeresen hozzáadva.",
            "updated": "Idősáv sikeresen frissítve.",
            "cancelled": "Az időpont sikeresen le lett mondva.",
            "uncancelled": "Az időpont lemondása sikeresen visszavonva.",
            "deleted": "Idősáv sikeresen törölve.",
            "deleteError": "Idősáv nem törölhető.",
            "exportSuccess": "Idősávok sikeresen exportálva.",
            "syncSuccess": "iCal szinkronizálás sikeresen befejeződött.",
            "syncError": "iCal szinkronizálás sikertelen. Kérlek ellenőrizd az iCal URL-t és próbáld újra.",
            "bulkAdded": "{{created}} idősáv létrehozva, {{skipped}} kihagyva (már létezik).",
            "rentalDayCreated": "Bérlési nap sikeresen létrehozva (az összes beállított sáv).",
            "rentalDayUpdated": "Bérlési nap sikeresen frissítve.",
            "bulkRentalDaysAdded": "{{created}} bérlési nap létrehozva, {{skipped}} kihagyva (már létezik)."
        },
        "alert": "Az iCal szinkronizálás engedélyezve van ehhez a műsorhoz. Kérlek vedd figyelembe, hogy ha eltávolítasz egy időpontot, a szinkronizálás újra létrehozhatja azt.",
        "syncButton": "iCal szinkronizálás",
        "syncing": "iCal szinkronizálás folyamatban...",
        "syncResults": {
            "title": "iCal szinkronizálás eredményei",
            "created": "Létrehozott időpontok",
            "removed": "Eltávolított időpontok",
            "noCreated": "Nincs létrehozott időpont.",
            "noRemoved": "Nincs eltávolított időpont.",
            "bookingCount": "({{count}} foglalás)",
            "bookingCount_plural": "({{count}} foglalás)",
            "warning": "Ezek az időpontok már nem találhatók az iCal naptárban, és manuálisan el kell távolítani őket, ha foglalások vannak."
        },
        "inlineEdit": {
            "editCapacity": "Kapacitás szerkesztése",
            "editNote": "Megjegyzés szerkesztése",
            "booked": "foglalt",
            "notePlaceholder": "Belső megjegyzés hozzáadása...",
            "unsavedTitle": "Nem mentett változások",
            "unsavedContent": "Nem mentett változások vannak. El szeretnéd vetni őket?",
            "discard": "Elvetés",
            "keepEditing": "Szerkesztés folytatása",
            "unlimited": "Korlátlan"
        },
        "priceMatrix": {
            "title": "Egyedi árak",
            "info": "Állíts be egyedi árakat ehhez az időponthoz. Az üres mezők a jegytípus alapértelmezett árát használják.",
            "ticketType": "Jegytípus",
            "noData": "Ehhez a műsorhoz nincs elérhető jegytípus vagy jegyopció.",
            "noPrice": "Alapértelmezett"
        },
        "errors": {
            "notICalEnabled": "Az iCal szinkronizálás nincs engedélyezve ehhez a műsorhoz.",
            "noICalUrl": "Nincs iCal URL megadva ehhez a műsorhoz.",
            "timezoneInfo": "Minden időpont a helyi időzónádban jelenik meg, és átalakítás nélkül kerül mentésre."
        },
        "assignment": {
            "title": "Ülőhely kiosztás",
            "delayedSeatSettingDisabled": "Az ülésszelekció be van kapcsolva ehhez a műsorhoz. Továbbra is használhatod ezt a képernyőt, de a vendégek már választhatnak helyet foglalás közben, és az automatikus helykiosztás aktív az adminban.",
            "suggest": "Ülőhelyek javaslata",
            "sendSeatingLockEmail": "Ülőhely email küldése",
            "sendingSeatingEmails": "Ülőhely emailek küldése…",
            "missingSeats": "Hiányzó ülőhelyek: {{count}}",
            "unassignedGroups": "Kiosztatlan csoportok",
            "allAssigned": "Minden foglalás ülőhelyet kapott ebben az időpontban.",
            "clearSeats": "Ülőhelyek törlése",
            "noBookings": "Nem található foglalás ehhez az időponthoz.",
            "paxAndMissing": "Személyek: {{pax}} | Hiányzik: {{missing}}",
            "requiredTicketTypes": "Szükséges: {{types}}",
            "bookingId": "Foglalás #{{id}}",
            "seatingLockEmailSent": "Ülőhely kiosztás email elküldve.",
            "seatingLockEmailSentOn": "Ülőhely email elküldve: {{-date}}",
            "resendSeatingLockEmail": "Ülőhely email újraküldése",
            "noCompatibleTicketType": "A kiválasztott ülőhely nem illeszkedik egyetlen kiosztatlan jegyhez sem ebben a foglalásban.",
            "seatUnavailable": "Ez az ülőhely már ki van osztva egy másik foglaláshoz.",
            "noMissingSeats": "Ennek a foglalásnak már minden ülőhelye ki van osztva.",
            "saved": "Ülőhely kiosztások mentve.",
            "crossTypeMismatchTooltip": "A kiosztott ülőhelyek nem egyeznek a kiosztandó jegytartalommal.",
            "sendSeatingEmail": "Ülőhely email küldése",
            "resendSeatingChangedEmail": "Ülőhely megváltozott — email újraküldése",
            "resendSeatingEmail": "Ülőhely email újraküldése",
            "seatingChangedEmailSent": "Ülőhely frissítési email elküldve.",
            "arrangementSeatConflict": "Ennek a foglalásnak van egy hozzárendelt helye, amely nem elérhető a kiválasztott elrendezésben.",
            "unassignAll": "Mindet feloldani",
            "unassignAllConfirmTitle": "Minden ülőhely kiosztásának feloldása",
            "unassignAllConfirmBody": "Biztosan eltávolítod mind a(z) {{count}} ülőhely-kiosztást ebből az időpontból? Ez minden foglalást érint.",
            "unassignAllSuccess": "{{count}} ülőhely-kiosztás feloldva.",
            "sortByCreatedAt": "Foglalás dátuma",
            "sortByBookingId": "Foglalás azonosító",
            "sortByName": "Név",
            "sortAsc": "Növekvő",
            "sortDesc": "Csökkenő",
            "tabUnassigned": "Hozzá nem rendelt",
            "tabAssigned": "Hozzárendelve",
            "tableUnknown": "Nincs asztal",
            "splitBookingTooltip": "Ez a foglalás több asztal között van megosztva",
            "showNotes": "Megjegyzések megjelenítése",
            "hideNotes": "Megjegyzések elrejtése"
        },
        "capacityReservations": "Foglalható ülőhelyek",
        "capacityReservationsInfo": "Add meg, hány ülőhely foglalható le jegytípusonként. Ha az aktuális eladott szám alá csökkented, előfordulhat, hogy manuálisan le kell mondanod foglalásokat, vagy át kell helyezned azokat másik időpontra.",
        "bookableHeader": "Foglalható",
        "totalHeader": "Összesen",
        "checkinClosedBanner": "Ennek az időpontnak a check-inje le van zárva. A recon összefoglaló rögzítve.",
        "cancelTimeslotButton": "Időpont lemondása",
        "uncancelTimeslotButton": "Lemondás visszavonása",
        "cancelledTitle": "Ez az esemény le lett mondva",
        "cancelledBanner": "Ez az időpont le van mondva",
        "cancelModal": {
            "title": "Időpont lemondása",
            "confirm": "Lemondás megerősítése",
            "customReasonLabel": "Egyedi ok"
        }
    },
    "checkinview": {
        "reopenButton": "Check-in újranyitása",
        "finishButton": "Check-in befejezése",
        "finishNote": "Befejező megjegyzés",
        "stats": {
            "checkedIn": "Bejelentkezve",
            "notCheckedIn": "Nem jelent meg",
            "sold": "Eladva (összes)",
            "soldDescription": "Bejelentkezett + nem jelent meg",
            "bySource": "Foglalási forrás szerint",
            "source": "Forrás",
            "sourceDirect": "Közvetlen",
            "byCustomerType": "Vásárlótípus szerint",
            "customerType": "Vásárlótípus",
            "email": "E-mail",
            "checkinNote": "Becsekkolási megjegyzés",
            "unpaidBalance": "Fizetendő egyenleg",
            "seated": "Ültetett",
            "unseated": "Nem ültetett",
            "note": "Megjegyzés",
            "manifest": "Manifeszt",
            "guest": "Vendég",
            "tickets": "Jegyek",
            "statusHeader": "Státusz",
            "revised": "Frissített",
            "revisedDescription": "A check-in újra lett nyitva, majd ismét lezárva — ez az összefoglaló felülírja az előzőt.",
            "suppressReviewEmail": "Visszajelzős e-mail letiltva"
        },
        "notifications": {
            "closed": "Check-in sikeresen lezárva.",
            "reopened": "Check-in sikeresen újranyitva.",
            "noteSaved": "Megjegyzés sikeresen mentve."
        },
        "suppressReviewEmail": "Visszajelzős e-mail letiltása",
        "groupByAgeBand": "Csoportosítás korcsoport szerint"
    },
    "bookings": {
        "model": "Foglalás",
        "title": "Foglalások",
        "audit": {
            "rentalDayMoved": "Bérlési nap áthelyezve"
        },
        "summary": {
            "totalBookings": "Összes foglalás",
            "totalRevenue": "Összes bevétel",
            "avgRevenue": "Átlag / Foglalás",
            "totalPersons": "Összes fő"
        },
        "columns": {
            "bookingId": "Foglalás azonosító",
            "status": "Státusz",
            "venueName": "Helyszín neve",
            "showName": "Show",
            "timeslot": "Időpont",
            "firstName": "Keresztnév",
            "lastName": "Vezetéknév",
            "phone": "Telefonszám",
            "email": "Email",
            "language": "Nyelv",
            "note": "Megjegyzés",
            "checkinNote": "Bejelentkezési megjegyzés",
            "agentName": "Ügynök neve",
            "commission": "Jutalék",
            "isCheckedIn": "Bejelentkezve",
            "confirmationCode": "Megerősítő kód",
            "isReviewEmailSuppressed": "Értékelési e-mail letiltása",
            "emailNotifications": "E-mail értesítések",
            "smsNotifications": "SMS értesítések",
            "emailNotificationsDisabled": "E-mail értesítések letiltva",
            "smsNotificationsDisabled": "SMS értesítések letiltva",
            "guest": "Vendég",
            "ticketTypes": "Jegytípusok",
            "pax": "Fő",
            "source": "Forrás",
            "paymentMethod": "Fizetési mód",
            "createdAt": "Létrehozva"
        },
        "newBooking": "Új foglalás",
        "create": "Létrehozás",
        "sourceOnline": "Online",
        "sourceAffiliate": "Affiliate",
        "sourceCallCenter": "Telefonos ügyfélszolgálat",
        "advancedFiltering": "Részletes szűrés",
        "clearAllFilters": "Minden szűrő törlése",
        "clearAll": "Összes törlése",
        "status": "Státusz",
        "filterLabels": {
            "id": "Azonosító",
            "confirmationCode": "Megerősítő kód",
            "status": "Státusz",
            "search": "Keresés",
            "show": "Műsor",
            "timeslot": "Időpont",
            "ticketType": "Jegytípus",
            "commissionGroup": "Jutalékos csoport",
            "paymentMethod": "Fizetési mód"
        },
        "notifications": {
            "added": "Foglalás sikeresen hozzáadva.",
            "updated": "Foglalás sikeresen frissítve.",
            "deleted": "Foglalás sikeresen törölve.",
            "deleteError": "Foglalás nem törölhető.",
            "cancelReservation": "Foglalás sikeresen lemondva.",
            "cancelReservationError": "Foglalás nem mondható le.",
            "exportSuccess": "Foglalások sikeresen exportálva.",
            "chargeSuccess": "Számla sikeresen terhelve."
        },
        "errors": {
            "phoneInvalid": "A telefonszám csak számokat, szóközt, -, (, ), + karaktereket tartalmazhat.",
            "phoneNotEmail": "A telefonszám mező nem lehet email cím."
        },
        "bookingDetails": "Foglalás részletei #{{bookingId}}",
        "rebookedTo": "Átfoglalva ide: {{code}}",
        "rebookedFrom": "Átfoglalva innen: {{code}}",
        "rollback": {
            "timeRemaining": "Visszagörgetésig hátralévő idő: {{time}}",
            "overdue": "A visszagörgetés esedékes — a kifizetetlen tételek hamarosan felszabadulnak"
        },
        "bookingDetailsNobooking": "Nincs foglalás ehhez az ülőhelyhez",
        "limitedModificationWarning": "Ez a foglalás külső integráción keresztül jött létre. Csak a megjegyzések, az ülőhelyek és az alapvető elérhetőségek módosíthatók. A visszatérítéseket és a lemondásokat az eredeti foglalási platformon keresztül kell kezelni.",
        "invoicedBookingWarning": "Ez a foglalás egy partneri számlához tartozik. A jegyek módosítása nem engedélyezett.",
        "unpaidOrdersWarning": "Egy rendelés kifizetésre vár.",
        "unsavedLeaveTitle": "Nem mentett változások",
        "unsavedLeaveMessage": "Vannak nem mentett változások, amelyek elvesznek. Biztosan elhagyja az oldalt?",
        "bookingContacts": "Foglalási kapcsolattartók",
        "reSource": {
            "title": "Foglalás újraforrásozása",
            "button": "Foglalás újraforrásozása",
            "success": "A foglalás sikeresen újraforrásozva.",
            "noCommissionGroup": "Nincs jutalékcsoport"
        },
        "resendOnContactChange": {
            "title": "Email újraküldése?",
            "message": "A kapcsolattartó email címe megváltozott. Újraküldjük az utolsó emailt (\"{{subject}}\") a következő címre: {{email}}?"
        },
        "editContacts": "Kapcsolattartók szerkesztése",
        "saveContacts": "Kapcsolattartók mentése",
        "editAdditionalInformation": "További információk szerkesztése",
        "saveAdditionalInformation": "További információk mentése",
        "cancelBooking": "Foglalás lemondása",
        "cancelBookingFullRefund": "Foglalás lemondása teljes visszatérítéssel",
        "cancelBookingWithRefund": "Foglalás lemondása {{refundValue}} visszatérítéssel",
        "cancelBookingWithNoRefund": "Foglalás lemondása visszatérítés nélkül",
        "overrideCancelPolicyLabel": "Lemondási szabály felülbírálása és visszatérítés kiadása",
        "overrideCancelPolicyHelp": "Ez a foglalás már a helyszín lemondási időablakán kívül van. A visszatérítés kiadása felülbírálja a szabványos szabályzatot, és bekerül az auditnaplóba.",
        "stillBillableLabel": "A partner felé mégis kiszámlázzuk ezt a lemondást",
        "stillBillableReasonField": "indok",
        "stillBillableReasonPrompt": "Miért maradjon rajta a partner számláján ez a lemondott foglalás? (pl. 24 órán belüli lemondás indoklás nélkül)",
        "stillBillableReasonPlaceholder": "Indok (kötelező, max. 200 karakter)",
        "contactVenue": "Kapcsolatfelvétel a helyszínnel",
        "contactVenueTitle": "Kapcsolatfelvétel a helyszínnel",
        "contactVenueMessage": "Vedd fel a kapcsolatot a helyszínnel közvetlenül a foglalásod ügyében",
        "changeDate": "Dátum/idő módosítása",
        "changeDateWarning": "A dátum/idő módosítása törli az összes jelenlegi ülőhely-kiosztást. A módosítás után újra ki kell osztani az ülőhelyeket.",
        "changePeriodLabel": "Bérlési időszak",
        "changePeriodTitle": "Átváltás erre: {{period}}",
        "changePeriodConfirm": "Átváltja ezt a foglalást erre: {{period}}? Ez {{impact}}. Az ülőhelyek mentéskor újra kiosztásra kerülnek.",
        "changePeriodCharge": "{{amount}} terhelést jelent",
        "changePeriodRefund": "{{amount}} visszatérítést jelent",
        "changePeriodNoCharge": "nem változtatja az árat",
        "changePeriodNoPrice": "A(z) {{types}} típushoz nincs ár a(z) {{period}} időszakra - ez a foglalás nem váltható át.",
        "capacityWarning": "Ez a foglalás túllépi a rendelkezésre álló kapacitást: {{details}}. A mentés le van tiltva — távolíts el jegyeket vagy válassz másik időpontot.",
        "capacityWarningOverbook": "Ez a foglalás túllép a rendelkezésre álló kapacitáson: {{details}}. A maradék kapacitás negatívba mehet, és az ültetést kézzel kell kezelni. Csak akkor erősítsd meg, ha szándékos.",
        "capacityWarningDetail": "{{ticketType}} (hozzáadva {{adding}}, elérhető {{available}})",
        "timeslotChanged": "Dátum/idő módosítva",
        "autoSeatAll": "Összes hely automatikus kiosztása",
        "autoSeatOne": "Hely automatikus kiosztása",
        "autoSeatFailed": "Nem sikerült automatikusan helyet kiosztani. Nincs elérhető hely.",
        "bookingId": "Foglalás azonosító",
        "email": "Email",
        "phone": "Telefonszám",
        "refundBookingWithAmount": "Foglalás visszatérítése {{refundValue}} összeggel",
        "refundBookingWithMaxAmount": "Foglalás visszatérítése a jelenlegi maximális összeggel: {{refundValue}}",
        "checkinStatus": "Bejelentkezési státusz",
        "statusValues": {
            "processing": "Folyamatban",
            "finished": "Befejezve",
            "cancelled": "Lemondva"
        },
        "searchById": "Keresés foglalás azonosító alapján",
        "searchByConfirmationCode": "Keresés megerősítő kód alapján",
        "importButton": "Importálás",
        "import": {
            "title": "Foglalások importálása FareHarborból",
            "connectToFareHarbor": "Csatlakozás a FareHarborhoz",
            "selectShow": "Előadás kiválasztása",
            "fareHarborUrl": "FareHarbor URL",
            "email": "Email",
            "password": "Jelszó",
            "connect": "Csatlakozás és adatok lekérése",
            "mapItems": "FareHarbor elemek hozzárendelése az előadás elemeihez",
            "fareHarborVendor": "Szolgáltató",
            "fareHarborProduct": "Termék",
            "fareHarborTicket": "Jegy",
            "mapTo": "Hozzárendelés",
            "doNotImport": "Ne importálja",
            "startImport": "Importálás indítása",
            "dryRun": "Próba futtatás (csak ellenőrzés, importálás nélkül)",
            "createMissingTimeslots": "Hiányzó időpontok létrehozása",
            "progress": "Importálás folyamata",
            "progressText": "{{finished}}/{{total}} voucher feldolgozva ({{imported}} sikeresen importálva)",
            "errorsTitle": "{{count}} hiba történt az importálás során",
            "connectionSuccess": "Sikeres csatlakozás a FareHarborhoz",
            "importSuccess": "{{count}} foglalás sikeresen importálva",
            "importCompletedWithErrors": "Importálás befejezve: {{imported}} foglalás importálva, {{errors}} hiba",
            "errors": {
                "fillAllFields": "Kérjük, töltse ki az összes mezőt",
                "connectionFailed": "A FareHarborhoz való csatlakozás sikertelen",
                "importFailed": "Az importálás sikertelen"
            }
        },
        "massAction": {
            "button": "Tömeges lemondás / visszatérítés",
            "modalTitle": "{{count}} foglalás tömeges művelete",
            "warning": "FIGYELEM - Ellenőrizd a vendégnevet és az aktivitás részleteit a végrehajtás előtt.",
            "selectedCount": "Kijelölve: {{count}}",
            "clearSelection": "Kijelölés törlése",
            "selectAllMatchingFilters": "Minden szűrésnek megfelelő foglalás kijelölése (összes oldal)",
            "selectAllHint": "Infó: A fejléc jelölőnégyzetével az összes szűrésnek megfelelő foglalás kijelölődik minden oldalon, nem csak az aktuálison.",
            "selectingAllPages": "Az összes szűrésnek megfelelő foglalás kijelölése folyamatban...",
            "selectAllError": "Nem sikerült az összes foglalást kijelölni.",
            "noOperableBookings": "A jelenlegi szűrőkkel nem található lemondható vagy visszatéríthető foglalás.",
            "noSelection": "Nincs kijelölt foglalás.",
            "operationType": "Művelet típusa",
            "cancelAndRefund": "Foglalás lemondása (visszatérítéssel)",
            "cancelWithoutRefund": "Foglalás lemondása (visszatérítés nélkül)",
            "refundOnly": "Csak visszatérítés",
            "operationHintCancelAndRefund": "Lemondja a kijelölt foglalásokat, és a választott visszatérítési számítás alapján visszatérítést indít.",
            "operationHintCancelWithoutRefund": "Lemondja a kijelölt foglalásokat visszatérítés nélkül.",
            "operationHintRefundOnly": "A foglalások aktívak maradnak, és a választott visszatérítési számítás alapján csak visszatérítés történik.",
            "refundCalculation": "Visszatérítés számítása",
            "refundFull": "Teljes visszatérítés (100%)",
            "refundPercentage": "Százalék (%)",
            "refundFixed": "Fix összeg ($)",
            "percentageInputLabel": "Visszatérítés százalékban",
            "fixedInputLabel": "Fix visszatérítési összeg",
            "executeButton": "Művelet indítása",
            "runningProgress": "Feldolgozás folyamatban...",
            "resultTitle": "Eredmények",
            "progressLabel": "{{completed}} / {{total}} kész ({{percent}}%)",
            "resultSuccess": "Sikeresen végrehajtva.",
            "resultFailed": "A művelet sikertelen.",
            "statusSuccess": "Sikeres",
            "statusFailed": "Sikertelen",
            "completedSuccess": "A tömeges művelet sikeresen lefutott ({{count}} foglalás).",
            "completedWithFailures": "A tömeges művelet részben sikertelen ({{failureCount}} hiba).",
            "invalidRefundAmount": "A visszatérítés összege legyen nagyobb, mint 0.",
            "maxRefundableTotal": "Max visszatéríthető (össz.):",
            "plannedRefundTotal": "Tervezett visszatérítés (össz.):",
            "gridHeaderId": "ID",
            "gridHeaderBooker": "Foglaló",
            "gridHeaderPlanned": "Tervezett",
            "gridHeaderMax": "Max"
        },
        "addBooking": "Foglalás hozzáadása",
        "cancellationReasonLabel": "Lemondás oka"
    },
    "crm": {
        "title": "Vendégek",
        "searchPlaceholder": "Keresés név, e-mail vagy telefon alapján…",
        "viewBooking": "Foglalás megtekintése",
        "bookings": "Foglalások",
        "bookingsCount": "{{count}} foglalás",
        "noBookings": "Nincs megjeleníthető foglalás.",
        "unknownName": "Ismeretlen",
        "columns": {
            "name": "Név",
            "email": "E-mail",
            "phone": "Telefon",
            "bookingCount": "Foglalások",
            "lastBooking": "Utolsó foglalás"
        }
    },
    "bookingitems": {
        "model": "Foglalási tétel",
        "title": "Foglalás",
        "paxSummary": "{{count}} PAX: {{breakdown}}",
        "cateringview": "Vendéglátási nézet",
        "checkinview": "Bejelentkezési nézet",
        "booker": "Foglaló",
        "columns": {
            "quantity": "Mennyiség",
            "ticketOptionName": "Jegy opció",
            "ticketTypeName": "Jegy típus",
            "ticketSeatName": "Jegy széke",
            "ticketCount": "Jegyek",
            "price": "Ár",
            "note": "Megjegyzés",
            "checkinNote": "Bejelentkezési megjegyzés",
            "showTitle": "Műsor címe",
            "originalPrice": "Eredeti ár: {{price}}",
            "priceWithTaxAndFees": "Adóval és díjakkal"
        },
        "notifications": {
            "checkinNote": {
                "updated": "Bejelentkezési megjegyzés sikeresen frissítve."
            },
            "exportSuccess": "Foglalási tételek sikeresen exportálva."
        },
        "netPriceDescription": "A nettó ár {{price}}, az adók és díjak nincsenek benne.",
        "noBookingForThisSeat": "Nincs foglalás ehhez az ülőhelyhez ezekkel a szűrőkkel",
        "modifyTickets": {
            "title": "Jegyek módosítása",
            "description": "Kérjük, ellenőrizze a listát, hogy mi módosul. A változtatásokat az „Igen” gombra kattintva erősítse meg.",
            "priceChange": "A foglalási ár {{oldPrice}} értékről {{newPrice}} értékre változott, ami új rendelés létrehozását eredményezi. A végső ár adókkal és díjakkal együtt {{newFinalPriceSum}}, ami korábban {{oldFinalPriceSum}} volt.",
            "priceChangeNetRate": "A foglalási ár {{oldFinalPriceSum}} értékről {{newFinalPriceSum}} értékre változott, ami új rendelés létrehozását eredményezi. A net-rate foglalásoknál a fizetendő összeg a listaár mínusz jutalék; adók és díjak nem kerülnek felszámításra.",
            "noChangesTitle": "Nincs módosítás",
            "noChangesContent": "Kérjük, erősítse meg, hogy nem végzett módosításokat a foglalási tételeken.",
            "error": "Hiba történt a jegyek módosításakor: {{error}}",
            "success": "Jegyek sikeresen módosítva.",
            "sendNotification": "Értesítés küldése a felhasználónak"
        },
        "editSeats": "Ülőhelyek szerkesztése",
        "saveSeats": "Ülőhelyek mentése",
        "unsavedChanges": "Nem mentett változások",
        "cancelEdit": "Szerkesztés megszakítása",
        "saveBlockedByCapacity": "Nem menthető — túllépi a rendelkezésre álló kapacitást. Túlfoglalási jogosultság szükséges.",
        "warningPendingOrders": "Függőben lévő megrendelések",
        "discardPendingTitle": "Függő módosítás visszavonása és szerkesztés",
        "discardPendingMessage": "Ennek a foglalásnak van egy fizetésre váró függő módosítása. Vond vissza, hogy újra szerkeszthesd a foglalást.",
        "discardPendingWarning": "A foglalt jegyek felszabadulnak. A korábbi módosításaid visszatöltődnek a szerkesztőbe, hogy mentés előtt finomíthasd őket.",
        "simplified": {
            "addTickets": "Jegyek hozzáadása",
            "currentTickets": "Jelenlegi jegyek",
            "noTickets": "Még nincsenek jegyek",
            "autoSeatingOnSave": "A helyek automatikusan ki lesznek osztva mentéskor",
            "seatsAssignedLater": "A helyek később lesznek kiosztva",
            "switchToSimplified": "Váltás egyszerű nézetre",
            "switchToDetailed": "Váltás részletes nézetre",
            "addToTable": "Hozzáadás a táblázathoz",
            "removeFromTable": "Eltávolítás a táblázatból",
            "dynamicPriceHint": "Dinamikus ár. Alapár {{base}}."
        },
        "validation": {
            "seatNotCompatible": "A hely nem kompatibilis a kiválasztott jegytípussal",
            "invalidCombination": "Ez a jegyopció nem értékesíthető a kiválasztott jegytípussal",
            "priceDifference": "Az ár eltér a javasolt ártól ({{price}})"
        },
        "seated": "Ülőhellyel",
        "unseated": "Ülőhely nélkül"
    },
    "bookingstatus": {
        "processing": "Feldolgozás alatt",
        "finished": "Befejezve",
        "cancelled": "Visszavonva"
    },
    "orderstatus": {
        "pending": "Függőben",
        "refunding": "Visszatérítés alatt",
        "settled": "Kifizetve",
        "rollback": "Visszafizetve",
        "refunded": "Visszatérítve"
    },
    "orders": {
        "model": "Rendelés",
        "title": "Rendelések",
        "titleWithTickets": "Rendelések és jegyek",
        "ticketTotal": "{{total}} összesen",
        "notPayable": "Ez a rendelés már nem fizethető.",
        "columns": {
            "id": "ID",
            "status": "Státusz",
            "amount": "Összeg",
            "createdAt": "Létrehozva",
            "rollbackTimeAt": "Visszafizetve"
        },
        "notifications": {
            "added": "Rendelés sikeresen hozzáadva.",
            "updated": "Rendelés sikeresen frissítve.",
            "deleted": "Rendelés sikeresen törölve.",
            "deleteError": "Rendelés nem törölhető.",
            "rollbacked": "Rendelés sikeresen visszafizetve.",
            "rollbackError": "Rendelés nem visszafizethető.",
            "moreTimeAdded": "További idő sikeresen hozzáadva.",
            "moreTimeError": "További idő nem adható hozzá.",
            "rollbackTimeSet": "Visszaállítási idő sikeresen beállítva."
        },
        "addMoreTime": "További visszaállítási idő hozzáadása",
        "customRollbackModal": {
            "title": "Egyéni visszaállítási idő beállítása",
            "nowLabel": "Jelenlegi idő (HST)",
            "targetLabel": "Cél visszaállítási idő",
            "fromNow": "múlva",
            "ago": "ezelőtt",
            "afterCurrent": "a jelenlegi visszaállítási idő után",
            "beforeCurrent": "a jelenlegi visszaállítási idő előtt"
        }
    },
    "paymentmethods": {
        "model": "Fizetési mód",
        "title": "Fizetési módok",
        "columns": {
            "id": "ID",
            "venueName": "Helyszín neve",
            "slug": "Slug",
            "name": "Név",
            "methodType": "Fizetési mód típusa",
            "agentOnly": "Csak ügynök",
            "noteRequired": "Megjegyzés kötelező",
            "percentage": "Százalék (%)",
            "usd": "Fix díj (USD)",
            "enabled": "Engedélyezve"
        },
        "newPaymentMethodTitle": "Új fizetési mód",
        "notifications": {
            "added": "Fizetési mód sikeresen hozzáadva.",
            "updated": "Fizetési mód sikeresen frissítve.",
            "deleted": "Fizetési mód sikeresen törölve.",
            "toggled": "Fizetési mód sikeresen átkapcsolva.",
            "deleteError": "Fizetési mód nem törölhető.",
            "toggleError": "Fizetési mód nem kapcsolható át."
        },
        "methodTypes": {
            "card": "kártya: Kártyás fizetés",
            "cash": "készpénz: Készpénzes fizetés",
            "net_rate": "net_rate: Nettó ár (a vendég a nettó árat fizeti)",
            "net_rate_company": "net_rate_company: Nettó ár (céges kártya a nettót fizeti)"
        },
        "netRateCompanyInfo": "A bizottsági csoport mentett céges kártyájáról kerül terhelésre a nettó összeg (kiskereskedelmi ár mínusz jutalék). Az ügynök a teljes kiskereskedelmi összeget külső úton szedi be az ügyféltől.",
        "paymentBlock": "Fizetési blokk"
    },
    "transactions": {
        "title": "Tranzakciók",
        "columns": {
            "id": "ID",
            "showName": "Műsor neve",
            "startTime": "Kezdési idő",
            "booker": "Foglaló",
            "finished": "Befejezve",
            "amount": "Összeg",
            "paymentInfo": "Fizetési információ",
            "createdAt": "Létrehozva",
            "payment_type": "Fizetési típus",
            "refund_note": "Visszatérítési megjegyzés",
            "finishedBy": "Végrehajtva általa",
            "processing_fee": "Feldolgozási díj",
            "total": "Összesen"
        },
        "showOnlyUnfinished": "Csak befejezetlen",
        "showOnlyFinished": "Csak befejezett",
        "fee": "díj",
        "status": {
            "completed": "Befejezve",
            "processing": "Feldolgozás alatt"
        },
        "processingFeeDescription": "További díj, amelyet a fizetési mód számít fel",
        "totalProcessingFees": "Összes feldolgozási díj",
        "processingFeeRefund": "A feldolgozási díjak csak teljes törlés esetén kerülnek visszatérítésre",
        "noteSaved": "Megjegyzés sikeresen mentve.",
        "editNote": "Megjegyzés szerkesztése",
        "editNoteTitle": "Tranzakciós megjegyzés szerkesztése",
        "noteLabel": "Megjegyzés",
        "changePaymentType": {
            "title": "Fizetési típus módosítása",
            "button": "Fizetési típus módosítása",
            "label": "Fizetési típus",
            "help": "Váltás egy másik, azonos feldolgozási díjú készpénzes fizetési típusra.",
            "success": "A fizetési típus sikeresen módosítva."
        },
        "processingFeeSaved": "Tranzakciós díj elmentve.",
        "editProcessingFee": "Tranzakciós díj szerkesztése",
        "editProcessingFeeTitle": "Tranzakciós díj szerkesztése",
        "processingFeeLabel": "Tranzakciós díj ($)"
    },
    "manualrefunds": {
        "title": "Manuális visszatérítések",
        "no_transactions": "Nincsenek készpénzes tranzakciók, amelyek manuális visszatérítést igényelnek.",
        "do_refund": "Visszatérítés végrehajtása",
        "already_refunded": "Már visszatérítve",
        "modal_title": "Manuális visszatérítés megerősítése",
        "transaction_details": "Tranzakció részletei",
        "modal_warning": "Ez a művelet a készpénzes tranzakciót manuálisan visszatérítettnek jelöli. Kérjük, győződjön meg arról, hogy a visszatérítést a rendszeren kívül feldolgozták, mielőtt megerősítené.",
        "note_label": "Megjegyzés",
        "note_placeholder": "Kérjük, adjon meg egy megjegyzést a visszatérítésről",
        "confirm_refund": "Visszatérítés megerősítése",
        "refund_success": "A manuális visszatérítést sikeresen befejezettnek jelöltük.",
        "refund_error": "A visszatérítés befejezettnek jelölése nem sikerült. Kérjük, próbálja újra."
    },
    "emaillogs": {
        "title": "Email naplók",
        "model": "Email napló",
        "unknownLogType": "Ismeretlen napló típus",
        "columns": {
            "userName": "Felhasználó neve",
            "to": "Címzett",
            "subject": "Tárgy",
            "result": "Eredmény",
            "content": "Tartalom",
            "created": "Létrehozva",
            "type": "Típus"
        },
        "resendEmail": "Email újraküldése",
        "emailHasBeenSentAgain": "Az email újraküldve.",
        "areYouSureResend": "Biztos benne, hogy újraküldi ezt az emailt?",
        "viewEmail": "Email megtekintése",
        "mail": "Email",
        "modal": {
            "date": "Dátum",
            "from": "Feladó",
            "to": "Címzett",
            "subject": "Tárgy",
            "result": "Eredmény",
            "sender": "Feladó cím"
        },
        "emailTester": "E-mail sablon tesztelő",
        "emailTesterTemplate": "Sablon",
        "emailTesterVariant": "Variáció",
        "emailTesterVariantDefault": "Alapértelmezett",
        "emailTesterLanguage": "Nyelv",
        "emailTesterSelectTemplate": "Válasszon egy sablont az előnézethez",
        "emailTesterDesktop": "Asztali nézet",
        "emailTesterMobile": "Mobil nézet"
    },
    "refundChunks": {
        "title": "Visszatérítési tételek",
        "columns": {
            "name": "Név",
            "max": "Maximális visszatérítés",
            "method": "Fizetési mód",
            "info": "Információ",
            "note": "Megjegyzés",
            "status": "Állapot",
            "refundStatus": "Visszatérítés állapota",
            "statusValues": {
                "pending": "Függőben",
                "refunded": "Visszatérítve"
            }
        },
        "refundAmount": "Visszatérítés összege",
        "refundButton": "Visszatérítés"
    },
    "refundModal": {
        "title": "Visszatérítés",
        "content": "Kérjük, adja meg a visszatérítendő összeget ehhez a foglaláshoz."
    },
    "widgetInformations": {
        "description": "Leírás",
        "hours": "Óra",
        "reviewer": "Értékelő",
        "reviewers": "Értékelők",
        "paymentDeadlineExpires": "Fizetési határidő lejár",
        "paymentExpiredTitle": "Fizetés lejárt",
        "paymentExpired": "A fizetési határidő lejárt, és a jelenlegi foglalása már nem érvényes. Kérjük, indítsa újra a foglalási folyamatot.",
        "restartBooking": "Foglalás újraindítása",
        "pricesFor": "Árak erre a dátumra és időpontra",
        "pricesForSelectedDateAndTime": "Árak a kiválasztott dátumra és időpontra"
    },
    "widgetStepNavigation": {
        "step1next": "Foglalás megkezdése",
        "step2back": "Vissza a dátumhoz",
        "step2next": "Válassz ülőhelyeket",
        "step3back": "Jegyek módosítása",
        "step3next": "Foglalási információk",
        "step4back": "Foglalás módosítása",
        "step4next": "Jegyek foglalása",
        "step5back": "Vissza a foglalási információkhoz",
        "step5retry": "Foglalás újrapróbálása"
    },
    "widgetSidebarSteps": {
        "datetime": "Dátum és időpont",
        "tickets": "Jegyek",
        "seats": "Ülőhelyek",
        "bookingInformation": "Foglalási információk"
    },
    "widgetDatePicker": {
        "multipleEventsOnSameDay": "Kezdési időpont",
        "emptyOption": "Idő nincs megadva",
        "selectedTimeslot": "Kezdési időpont",
        "nextMonth": "Következő hónap",
        "prevMonth": "Előző hónap",
        "selectMonth": "Hónap kiválasztása",
        "prevYear": "Előző év",
        "nextYear": "Következő év",
        "dateAndTime": "Dátum és idő",
        "selectPeriod": "Bérlési sáv kiválasztása:"
    },
    "widgetLocale": "hu-HU",
    "widgetFooter": {
        "notice": "Minden ár amerikai dollárban értendő.",
        "poweredBy": "A szolgáltatást nyújtja:",
        "poweredByLink": "https://www.fire-knife.com/"
    },
    "widgetInfo": {
        "selectTickets": "Válaszd ki a jegyeket",
        "totalPrice": "Teljes ár:",
        "selectYourSeats": "Válaszd ki az ülőhelyeidet",
        "selectedSeats": "Kiválasztott ülőhelyek:",
        "noSeatingForThisTicket": "Nincs ülőhely ehhez a jegyhez",
        "suggestedSeats": "Javasolt ülőhelyek",
        "acceptSuggestedSeats": "Javasolt ülőhelyek elfogadása",
        "clearSeats": "Ülőhelyek törlése",
        "invalidSuggestion": "Nincs elég szabad ülőhely",
        "suggested": "Javasolt",
        "noSeatingRequired": "Nincs szükség ülőhely-választásra",
        "seatsAssignedBeforeEvent": "Az ülőhelyek az esemény előtt kerülnek kiosztásra",
        "switchTicketType": "Váltás"
    },
    "widgetBookingSummary": {
        "cancellationPolicy": "Lemondási feltételek",
        "needToKnow": "Fontos tudnivalók",
        "bookingSummaryTitle": "Foglalási összegzés",
        "tableColumns": {
            "quantity": "Mennyiség",
            "name": "Jegy név (SKU)",
            "pricePerItem": "Ár darabonként",
            "totalCost": "Teljes ár"
        },
        "taxes": "Adók",
        "fees": "Illetékek",
        "fee": "illeték",
        "tax": "adó",
        "subtotal": "Részösszeg",
        "subtotalNet": "Részösszeg (Nettó)",
        "totalFees": "Összes illeték",
        "totalTaxes": "Összes adó",
        "total": "Teljes összeg",
        "grandTotal": "Végösszeg",
        "bookingTotal": "Összesen",
        "bookingFee": "Foglalási díj",
        "bookingFeeInfo": "Foglalási díj információ",
        "bookingFeeInfoText": "A foglalási díj tartalmazza a vonatkozó adókat és illetékeket.",
        "ticketTypeLabel": "Jegy típus",
        "seatLabel": "Ülőhely",
        "pendingRemoved": "A fizetés befejezése után ez az elem eltávolításra kerül a foglalásból.",
        "pendingAdd": "A fizetés befejezése után ez az elem véglegesítésre kerül.",
        "otherFees": "Egyéb illetékek"
    },
    "widgetBookingInformation": {
        "contactInformation": "Kapcsolattartó információk",
        "firstName": "Keresztnév",
        "lastName": "Vezetéknév",
        "name": "Név",
        "email": "Email",
        "phone": "Telefonszám",
        "emailError": "Érvénytelen e-mail formátum, kérjük ellenőrizze az e-mail címét.",
        "phoneError": "Adjon meg érvényes telefonszámot (csak szám, szóköz, -, (, ), vagy + engedélyezett).",
        "smsNotificationInfo": "Ha beállítja, SMS értesítést küldünk a foglalásáról.",
        "seatingGroupCheckbox": "Barátaimmal szeretnék ülni",
        "seatingGroupDescription": "Csapatunk mindent megtesz, hogy együtt ültessen benneteket. Hagyjon egy megjegyzést, hogy össze tudjuk kötni a foglalásokat — minél részletesebb, annál jobb.",
        "seatingGroupNoteLabel": "Kivel ül együtt?",
        "seatingGroupNotePlaceholder": "pl. Kovács János, foglalási kód #1234 vagy 'Kovács család'",
        "seatingGroupNoteRequired": "Kérjük, adjon meg egy megjegyzést, hogy azonosíthassuk a csoportját"
    },
    "widgetWaitlist": {
        "changeTickets": "Jegyek módosítása",
        "unavailableTitle": "Jelenleg nem foglalható",
        "selectedTicketsStatus": "Kiválasztott jegyek állapota",
        "joinTitle": "Csatlakozás a várólistához",
        "joinDescription": "Add meg lent az adataidat, és értesítünk, ha a kiválasztott jegyeidhez elérhetővé válnak helyek.",
        "statusAvailable": "Elérhető",
        "statusSoldOut": "Elfogyott",
        "joinButton": "Feliratkozás a várólistára",
        "noPaymentRequired": "Ez csak várólista-feliratkozás.\nMost nincs szükség fizetésre.",
        "bookingSummaryTitle": "Foglalási összegzés",
        "waitlistLabel": "Várólista",
        "waitlistAvailable": "Várólista elérhető",
        "requestSubmitted": "Kérelem elküldve",
        "contactLabel": "Kapcsolat",
        "contactConfirmed": "Megerősítve",
        "waitlistStatusLabel": "Várólista állapota:",
        "pendingAvailability": "Elérhetőségre vár",
        "noPaymentProcessed": "A várólistás tételekre nem történt fizetés.",
        "successTitle": "Sikeresen felkerültél a várólistára!",
        "successDescriptionRich": "Megkaptuk az igényedet a következő jegyekre: <strong>{{tickets}}</strong>, erre az időpontra: <strong>{{date}}</strong>. Értesítünk a(z) <email>{{email}}</email> címen, amint elérhetővé válnak a helyek.",
        "returnHome": "Vissza a főoldalra"
    },
    "upgrades": {
        "pageTitle": "Upgrade-ek",
        "sendingOffers": "Ajánlatok küldése...",
        "selectShowAndTimeslot": "Válassz előadást és időpontot az upgrade ajánlatok megtekintéséhez",
        "empty": "Nincs elérhető upgrade ajánlat",
        "emptyFiltered": "Egyetlen upgrade ajánlat sem illeszkedik a jelenlegi szűrőkhöz",
        "upgradePaths": "Upgrade útvonalak",
        "fromTicketType": "Forrás jegytípus",
        "toTicketType": "Cél jegytípus",
        "addPath": "Útvonal hozzáadása",
        "removePath": "Útvonal törlése",
        "pathAdded": "Upgrade útvonal hozzáadva",
        "pathRemoved": "Upgrade útvonal törölve",
        "notify": {
            "offerSent": "Upgrade ajánlat elküldve",
            "reminderSent": "Emlékeztető elküldve",
            "dismissed": "Ajánlat visszavonva",
            "bulkSent": "{{count}} ajánlat elküldve",
            "bulkSkipped": "{{count}} ajánlat kihagyva",
            "bulkFailed": "{{count}} ajánlat sikertelen"
        },
        "actions": {
            "sendOffer": "Ajánlat küldése",
            "sendBulkOffer": "Csoportos ajánlat küldése",
            "sendReminder": "Emlékeztető küldése",
            "dismiss": "Elutasítás",
            "dismissBookingConfirm": "Biztosan kizárod ezt a foglalást az upgrade-re jogosultak közül?",
            "dismissOfferConfirm": "Biztosan visszavonod ezt az upgrade ajánlatot? Ez rollbacket indít.",
            "applyUpgrade": "Upgrade alkalmazása"
        },
        "errors": {
            "priceUnavailable": "Az upgrade nem alkalmazható automatikusan - a cél jegyár nem érhető el. Kérjük, módosítsa a foglalást kézzel."
        },
        "columns": {
            "guest": "Vendég",
            "group": "Csoport",
            "upgradeTo": "Upgrade erre",
            "priceDifference": "Árkülönbözet",
            "status": "Állapot",
            "activity": "Aktivitás",
            "actions": "Műveletek"
        },
        "status": {
            "eligible": "Jogosult",
            "sent": "Elküldve",
            "settled": "Lezárva",
            "expired": "Lejárt",
            "declined": "Elutasítva",
            "neverNotified": "Nincs értesítve"
        },
        "filters": {
            "show": "Előadás",
            "timeslot": "Időpont",
            "search": "Keresés",
            "searchPlaceholder": "Keresés név, e-mail vagy foglalási kód alapján",
            "eligibleOnly": "Csak jogosultak",
            "neverNotifiedOnly": "Csak nem értesítettek"
        },
        "activity": {
            "lastNotified": "Utolsó értesítés",
            "sentTimes": "{{count}} alkalommal elküldve"
        },
        "labels": {
            "noPhone": "Nincs telefonszám"
        }
    },
    "widgetReservationInfo": {
        "title": "Foglalási információk",
        "startTime": "Kezdési időpont",
        "reservationId": "Foglalás azonosító",
        "contactInformation": "Kapcsolattartási információk",
        "contactInformationAndOtherData": "Kapcsolattartási és egyéb adatok",
        "status": "Állapot",
        "payment": "Fizetés",
        "statusValues": {
            "processing": "Folyamatban",
            "finished": "Befejezve",
            "cancelled": "Lemondva",
            "pending": "Függőben"
        },
        "orders": {
            "title": "Rendelések",
            "orderId": "Azonosító",
            "amount": "Összeg",
            "status": "Állapot",
            "createdAt": "Létrehozva",
            "rollbackTimeAt": "Visszaállítás ideje",
            "statusValues": {
                "pending": "Függőben",
                "refunding": "Visszatérítés folyamatban",
                "settled": "Rendezve",
                "rollback": "Visszaállítva",
                "refunded": "Visszatérítve"
            }
        },
        "transaction": {
            "statusValues": {
                "finished": "Befejezve",
                "inprogress": "Folyamatban",
                "pending": "Függőben"
            },
            "amount": "Összeg",
            "transactionId": "Tranzakció azonosító",
            "status": "Állapot",
            "paymentMethod": "Fizetési mód",
            "date": "Dátum",
            "discountReversalLabel": "Kedvezmény visszavonása"
        },
        "paymentMethods": {
            "title": "Fizetési módok",
            "amountLabel": "Ebben a tranzakcióban fizetendő:",
            "note": "Megjegyzés"
        },
        "card": {
            "oldCard": "{{cardLast4}} végződésű kártya lejárati dátuma: {{expMonth}}/{{expYear}}",
            "newCard": "Új kártya regisztrálása"
        },
        "notes": "Egyéb információk",
        "payButton": "Fizetés",
        "refundChunks": {
            "title": "Visszatérítési tételek",
            "name": "Név",
            "max": "Maximális visszatérítés",
            "method": "Fizetési mód",
            "info": "Információ",
            "note": "Megjegyzés",
            "status": "Állapot",
            "refundStatus": "Visszatérítés állapota",
            "statusValues": {
                "pending": "Függőben",
                "refunded": "Visszatérítve"
            },
            "refundAmount": "Visszatérítési összeg",
            "refundButton": "Visszatérítés",
            "invalidAmount": "Érvénytelen összeg",
            "fullRefundRequired": "A teljes visszatérítési összeget ({{amount}}) el kell osztania az összes rendelkezésre álló fizetési módra.",
            "couponContactAgent": "A foglaláshoz kupon tartozik, ezért a visszatérítést erről az oldalról nem lehet indítani. A visszatérítéshez kérjük, vedd fel a kapcsolatot a helyszínnel.",
            "contactVenueButton": "Kapcsolatfelvétel a helyszínnel"
        },
        "paymentDetails": {
            "oneTimePayment": "Fizetés egyösszegben",
            "splitPayment": "Fizetés szétosztása",
            "single": "Egyösszegben",
            "split": "Szétosztás",
            "payableAmount": "Fizetendő összeg:",
            "processingFee": "Kezelési díj",
            "processingFeeDisclaimer": "A külföldi kártyák és a részletfizetés extra költségekkel járhatnak.",
            "totalCharge": "Teljes terhelés",
            "processingFeeWillBeIncluded": "Processing fee will be included in the total charge. The processing fee is: {{fee}}",
            "includesProcessingFee": "Tartalmaz {{fee}} kezelési díjat",
            "wantToSplit": "Szeretnéd megosztani a fizetést?",
            "remainingNotice": "A fennmaradó {{amount}} összeg egy következő tranzakcióban lesz fizethető.",
            "paymentXofY": "{{current}}. fizetés / {{max}}",
            "unlimitedSplitPayments": "Korlátlan részletszám engedélyezve"
        }
    },
    "image": {
        "upload": "Kép feltöltése",
        "remove": "Kép eltávolítása",
        "uploading": "Kép(ek) feltöltése, kérjük várjon...",
        "add": "Kép hozzáadása",
        "image": "Kép",
        "imageUrl": "Kép URL",
        "imageUrlPlaceholder": "https://example.com/image.jpg",
        "imageUploadError": "Hiba történt a kép feltöltésekor",
        "uploadStarted": "Feltöltés megkezdődött",
        "uploadFinished": "Feltöltés befejezve",
        "imageViewer": "Kép néző",
        "previousImage": "Előző kép",
        "nextImage": "Következő kép",
        "closeGallery": "Galéria bezárása"
    },
    "richtext": {
        "linkDescription": "Add meg a link URL-jét és a megjelenítendő szöveget. A link új lapon fog megnyílni.",
        "imageDescription": "Tölts fel egy képet, vagy add meg a kép URL-jét. A kép teljes szélességben fog megjelenni a tartalomban.",
        "linkTextPlaceholder": "Megjelenítendő szöveg",
        "displayAsButton": "Megjelenítés gombként"
    },
    "onboarding": {
        "title": "Beillesztési folyamat",
        "description": "A widget használatához a weboldalán, a következő kódrészletet a weboldala </body> záró tagja elé kell beillesztenie.",
        "way1": "A foglalási modál megnyitásához hívja meg a következő javascript függvényt (kérjük, vegye figyelembe, hogy a 1234 a műsor azonosítója):",
        "way2": "A következő HTML kódrészletet is használhatja egy foglalási gomb beágyazásához a weboldalán (kérjük, vegye figyelembe, hogy a 1234 a műsor azonosítója):",
        "way3": "Minden műsornak van egy egyedi widget slug-ja, ezért rendkívül fontos, hogy a megfelelő azonosítót használja a modálhoz vagy gombhoz. Íme a műsorok és kódjaik:",
        "showName": "Műsor neve",
        "showCall": "Műsor hívása",
        "directSite": "Közvetlen webhely",
        "showId": "Műsor azonosító",
        "bookNow": "Foglalj most"
    },
    "emails": {
        "subjects": {
            "iCalSyncTimeslotsUpdated": "iCal szinkronizálás – Időpontok frissítve",
            "completeYourReservation": "Foglalás befejezése – Ne maradj le!",
            "showReminderTomorrow": "Emlékeztető: {{showTitle}} holnap!",
            "reviewExperience": "Milyen volt az élményed a(z) {{showTitle}} műsoron?",
            "refundsRequiringAttention": "Visszatérítések figyelmet igényelnek",
            "refundProcessed": "Visszatérítés feldolgozva",
            "welcomeToFireknife": "Üdvözlünk a Fireknife-nál! Jelentkezz be a kezdéshez",
            "passwordReset": "Fireknife – Jelszó visszaállítása",
            "bookingUpdated": "Foglalás frissítve",
            "bookingCancelled": "Foglalás lemondva",
            "bookingCancelledFullRefund": "Foglalás lemondva – Teljes visszatérítés",
            "paymentRequired": "Fizetés szükséges",
            "reservationConfirmed": "Foglalásod megerősítve",
            "abandonedCart": "Foglalás befejezése – Ne maradj le!",
            "adminRefundNotification": "Visszatérítések figyelmet igényelnek",
            "waitlistTicketsAvailable": "Elérhetővé váltak jegyek erre: {{showTitle}}",
            "affiliateInvoiceDispatch": "Partneri számla {{-showDateFrom}} - {{-showDateTo}}",
            "bookingDateChanged": "A foglalás dátuma megváltozott",
            "upgradeOffer": "Elérhető upgrade a foglalásodhoz",
            "checkinClosed": "Check-in lezárva - Összefoglaló",
            "waitlistSeatsAvailable": "Várólistás jelentkezések teljesíthetők",
            "upgradeEligibleNotify": "Frissítésre jogosult foglalások"
        },
        "messages": {
            "passwordResetSent": "Jelszó visszaállítás elküldve!",
            "passwordResetEmailSent": "Jelszó visszaállító e-mail elküldve!",
            "inviteFails": "Nem sikerült elküldeni a meghívó e-mailt. Kérjük, ellenőrizze az e-mail címet és próbálja újra.",
            "passwordResetFails": "A jelszó visszaállítása nem sikerült. Kérjük, próbálja meg később újra.",
            "cancelFails": "Nem sikerült elküldeni a foglalás lemondásáról szóló e-mailt.",
            "paymentNeededFails": "Nem sikerült elküldeni a fizetési felszólítást tartalmazó e-mailt a foglaláshoz.",
            "refundConfirmationFails": "Nem sikerült elküldeni a visszatérítés megerősítéséről szóló e-mailt a foglaláshoz.",
            "waitlistReminderFails": "Nem sikerült elküldeni a várólistás értesítő e-mailt."
        }
    },
    "svgeditor": {
        "chair": "Szék",
        "table": "Asztal",
        "table2": "Asztal 2",
        "table3": "Asztal 3",
        "table4": "Asztal 4",
        "table5": "Asztal 5",
        "table6": "Asztal 6",
        "stage": "Színpad",
        "fitToFloorplan": "Alaprajzhoz igazítás",
        "zoomIn": "Nagyítás",
        "zoomOut": "Kicsinyítés"
    },
    "payment": {
        "paymentStarted": "Fizetés elindítva, kérjük ellenőrizze a tranzakció állapotát egy pillanat múlva.",
        "paymentXofY": "{{current}}. fizetés / {{max}}",
        "unlimitedSplitPayments": "Korlátlan részletszám engedélyezve"
    },
    "formik": {
        "showPassword": "Jelszó megjelenítése",
        "hidePassword": "Jelszó elrejtése"
    },
    "email": {
        "abandoned_cart": {
            "title": "Ne maradj le a foglalásodról!",
            "body1": "Egy fantasztikus esemény vár rád! Észrevettük, hogy néhány jegyet hagytál a kosaradban anélkül, hogy befejezted volna a foglalást.<br/><br/>Ne aggódj, a kosarad még mentve van, de <b>siess</b>, hogy befejezd a foglalást, mielőtt elfogynak a jegyek!",
            "ticketsTitle": "Jegyek",
            "buttonLabel": "Foglalás befejezése"
        },
        "admin_refund_notify": {
            "title": "Lemondás az időablakon belül",
            "body1": "Néhány foglalás lemondásra került a lemondási időablakon belül, ha valamelyik vendég visszatérítést kér, nyugodtan térítsd vissza neki.",
            "guestHeader": "Vendég",
            "bookingHeader": "Foglalás",
            "buttonLabel": "Foglalás megtekintése"
        },
        "booking_update_notify": {
            "title": "Foglalás frissítve",
            "subtitle": "Frissítési értesítés az ügynöktől",
            "body1": "A foglalásodat frissítette csapatunk. Íme a részletek:",
            "messageFrom": "Üzenet {{agentName}}-tól:",
            "buttonLabel": "Foglalás kezelése",
            "summaryTitle": "Frissített foglalási összegzés",
            "dateChangedTitle": "Dátum és időpont módosult",
            "previousDateLabel": "Korábbi:",
            "newDateLabel": "Új:"
        },
        "cancel_full_refund": {
            "title": "Foglalás lemondva – Teljes visszatérítés",
            "subtitle": "A(z) {{showName}} foglalásod lemondva",
            "body1": "A foglalásod sikeresen lemondva, és teljes visszatérítést kapsz.",
            "cancellationReasonLabel": "Lemondás oka:",
            "refundAmountLabel": "Visszatérítés összege:",
            "refundMethodLabel": "Visszatérítés módja:",
            "refundTimeframeLabel": "Várható visszatérítési idő:",
            "cancelledStatus": "LEMONDVA",
            "summaryTitle": "Lemondott foglalás összegzése",
            "contactUsTitle": "Kapcsolat",
            "contactUsBody": "Ha kérdésed van a lemondással vagy visszatérítéssel kapcsolatban, vedd fel velünk a kapcsolatot:"
        },
        "cancel_inside_window": {
            "title": "Foglalás lemondva",
            "subtitle": "A(z) {{showName}} foglalásod lemondva",
            "body1": "A foglalásod a lemondási időablakon belül lett lemondva.",
            "cancellationReasonLabel": "Lemondás oka:",
            "cancellationPolicyLabel": "Lemondási feltételek:",
            "refundAmountLabel": "Visszatérítés összege:",
            "refundMethodLabel": "Visszatérítés módja:",
            "refundTimeframeLabel": "Várható visszatérítési idő:",
            "noRefund": "Visszatérítés: Nem jár visszatérítés a lemondás időpontja miatt.",
            "cancelledStatus": "LEMONDVA",
            "summaryTitle": "Lemondott foglalás összegzése",
            "contactUsTitle": "Kapcsolat",
            "contactUsBody": "Ha kérdésed van a lemondással kapcsolatban, vedd fel velünk a kapcsolatot:"
        },
        "cancel_partial_refund": {
            "title": "Foglalás lemondva",
            "subtitle": "A(z) {{showName}} foglalásod lemondva",
            "body1": "A foglalásod részleges visszatérítéssel lett lemondva.",
            "cancellationReasonLabel": "Lemondás oka:",
            "cancellationPolicyLabel": "Lemondási feltételek:",
            "refundAmountLabel": "Visszatérítés összege:",
            "refundMethodLabel": "Visszatérítés módja:",
            "refundTimeframeLabel": "Várható visszatérítési idő:",
            "noRefund": "Ehhez a lemondáshoz nem jár visszatérítés.",
            "cancelledStatus": "LEMONDVA",
            "summaryTitle": "Lemondott foglalás összegzése",
            "contactUsTitle": "Kapcsolat",
            "contactUsBody": "Ha kérdésed van a lemondással kapcsolatban, vedd fel velünk a kapcsolatot:"
        },
        "delete_timeslot": {
            "title": "iCal szinkronizálás eredménye",
            "body1": "<b>{{showName}}</b> esetén az iCal naptár szinkronizálása a következő eredményt hozta.",
            "createdTimeslotsTitle": "Létrehozott idősávok",
            "noNewTimeslots": "Nem jött létre új idősáv.",
            "removedTimeslotsTitle": "Eltávolítandó idősávok",
            "noRemovedTimeslots": "Nincs eltávolítandó idősáv.",
            "bookingCount": "({{count}} foglalás)",
            "removedTimeslotsInfo": "Ezek az idősávok már nem érhetők el az iCal naptárban, és el kell távolítani őket a rendszerből. Ez nem történik meg automatikusan, mivel lehetnek foglalások ezekhez az idősávokhoz."
        },
        "existinguserinvite": {
            "greeting": "Szia {{name}}!",
            "body1": "Fel lettél kérve, hogy jelentkezz be a(z) {{venue}} helyszínre. Kérlek, kattints az alábbi gombra a platform eléréséhez.",
            "buttonLabel": "Kattints ide a bejelentkezéshez."
        },
        "invite": {
            "greeting": "Szia {{name}}!",
            "body1": "Meghívást kaptál a(z) {{venue}} Fireknife platformjára. Kérlek, kattints az alábbi gombra a jelszó létrehozásához.",
            "commissionGroupContext": "Hozzáadtak a(z) „{{groupName}}” jutalékcsoporthoz.",
            "showContext": "Ez a csoport a következő előadáshoz tartozik: {{showTitle}}.",
            "buttonLabel": "Kattints ide új jelszó létrehozásához."
        },
        "affiliatetools": {
            "title": "A te affiliate foglalási linked",
            "body1": "Az alábbi linken keresztül létrejött foglalások automatikusan hozzád kerülnek jóváírásra. Saját UTM paramétereket is hozzáfűzhetsz a kampányaid követéséhez.",
            "codeLabel": "Az affiliate kódod:",
            "linkLabel": "A foglalási linked:"
        },
        "payment_needed": {
            "title": "Fizetés szükséges",
            "subtitle": "Foglalásod befejezése a(z) {{showName}} eseményre",
            "body1": "A foglalásod majdnem kész! A foglalás véglegesítéséhez fizetés szükséges.",
            "paymentDueByLabel": "Fizetési határidő:",
            "buttonLabel": "Fizetés befejezése",
            "summaryTitle": "Foglalás összegzése"
        },
        "waitlist_reminder": {
            "title": "Jó hír, elérhetőek a jegyek",
            "subtitle": "A kért jegyeid a(z) {{showName}} műsorra most foglalhatók",
            "body1": "Szia {{subscriberName}}, a teljes kért jegykombináció jelenleg elérhető. Kattints alább a foglalás folytatásához.",
            "buttonLabel": "Foglalás most",
            "summaryTitle": "Kért jegyek"
        },
        "upgrade_offer": {
            "title": "Elérhető upgrade",
            "greeting": "Szia {{name}},",
            "vipAvailable": "Korlátozott ideig elérhető egy upgrade a(z) {{date}} időpontú foglalásodhoz. Nézd át a részleteket lent, és erősítsd meg, ha szeretnéd igénybe venni.",
            "currentTicketsTitle": "Upgrade-elendő jegyek",
            "upgradeTicketsTitle": "Upgrade után",
            "priceDifference": "Különbözet:",
            "deadline": "Ajánlat lejár:",
            "payNow": "Upgrade elfogadása"
        },
        "post_show_review": {
            "title": "Köszönjük, hogy részt vettél a(z) {{showName}} eseményen!",
            "buttonLabel": "Értékelés írása"
        },
        "pwreset": {
            "greeting": "Szia {{name}}!",
            "body1": "A jelszavad vissza lett állítva. Kattints az alábbi gombra az új jelszó létrehozásához.",
            "buttonLabel": "Kattints ide új jelszó létrehozásához."
        },
        "refund_confirmation": {
            "title": "Visszatérítés feldolgozva",
            "subtitle": "A visszatérítésed feldolgozásra került",
            "body1": "Visszatérítést kaptál a foglalásodra. A fizetési módtól függően további lépésekre vagy időre lehet szükség, hogy a visszatérítés megjelenjen a számládon.",
            "totalRefundAmountLabel": "Teljes visszatérítés összege:",
            "processingFeeReturnedLabel": "Visszatérített tranzakciós díj:",
            "refundBreakdownLabel": "Visszatérítés részletezése:",
            "refundChunkLabel": "Visszatérítés {{index}}:",
            "amountLabel": "Összeg:",
            "methodLabel": "Mód:",
            "discountReversalLabel": "Típus:",
            "discountReversalValue": "Kedvezmény visszavonás (pénz nem mozog)",
            "transactionIdLabel": "Tranzakció azonosító:",
            "timeframeLabel": "Várható feldolgozási idő:",
            "refundReasonLabel": "Visszatérítés oka:",
            "refundAmountLabel": "Visszatérítés összege:",
            "refundMethodLabel": "Visszatérítés módja:",
            "refundProcessedStatus": "VISSZATÉRÍTÉS FELDOLGOZVA",
            "summaryTitle": "Visszatérített foglalás összegzése",
            "contactUsTitle": "Kapcsolat",
            "contactUsBody": "Ha kérdésed van a visszatérítéssel kapcsolatban, vedd fel velünk a kapcsolatot:"
        },
        "checkinLabel": "Bejelentkezés:",
        "showStartsLabel": "Előadás kezdése:",
        "checkinAndShowStartsLabel": "Bejelentkezés és előadás kezdése:",
        "reservation_created": {
            "title": "Megkaptuk a foglalásod!",
            "subtitle": "Üzenet a(z) {{venueName}} helyszíntől",
            "buttonLabel": "Foglalás kezelése",
            "cancellationPolicyTitle": "Lemondási feltételek",
            "needToKnowTitle": "Fontos tudnivalók",
            "summaryTitle": "Foglalás összegzése"
        },
        "show_reminder": {
            "title": "Hamarosan találkozunk!",
            "subtitle": "Holnap a(z) {{venueName}} helyszínen",
            "buttonLabel": "Foglalás kezelése",
            "cancellationPolicyTitle": "Lemondási feltételek",
            "needToKnowTitle": "Fontos tudnivalók",
            "summaryTitle": "Foglalás összegzése",
            "checkInTimeLabel": "Érkezési idő",
            "tableAssignmentLabel": "Asztal kiosztás"
        },
        "seating_locked": {
            "subject": "Megváltozott az ülőhelyed a(z) {{showTitle}} rendezvényhez",
            "title": "Az ülőhely-kiosztás frissült",
            "reminderMessage": "Az ülőhely-kiosztás frissült. Kérjük, tekintse át az új asztal kiosztást és az érkezési időt az alábbiakban.",
            "checkInTimeLabel": "Érkezési idő",
            "assignmentLabel": "Asztal kiosztás",
            "assignmentLabelTable": "Asztal kiosztás",
            "assignmentLabelSeat": "Ülőhely kiosztás",
            "buttonLabel": "Foglalás megtekintése",
            "summaryTitle": "Foglalás összegzése"
        },
        "seating_locked_manifest_copy": {
            "subject": "Ülőhely manifeszt: {{showTitle}}",
            "intro": "Az ülőhely-kiosztásokat éppen kiküldtük a vendégeknek. Az alábbi az aktuális érkezési manifeszt.",
            "manifest": "Manifeszt"
        },
        "parts": {
            "cart": {
                "totalLabel": "Összesen",
                "subTotalLabel": "Részösszeg",
                "taxesLabel": "Adók",
                "feesLabel": "Illetékek",
                "bookingFeeLabel": "Foglalási díj",
                "processingFeeNote": "Kártyás fizetés esetén {{amount}} feldolgozási díj kerül felszámításra.",
                "processingFeeLabel": "Feldolgozási díj",
                "grandTotalLabel": "Végösszeg",
                "discountLabel": "Kedvezmény",
                "previouslyRefundedLabel": "Korábban visszatérítve",
                "refundThisTimeLabel": "Most visszatérített összeg"
            },
            "footer": {
                "copyright": "© {{year}} {{appName}}. Minden jog fenntartva."
            },
            "venue": {
                "addressLabel": "Cím",
                "phoneLabel": "Telefon",
                "reachUsAt": "Elérhetsz minket itt:",
                "getDirectionLabel": "Útvonalterv",
                "viewDirections": "Útvonal megtekintése és utazás tervezése"
            }
        },
        "affiliate_invoice_dispatch": {
            "remitTo": "Kedvezményezett",
            "billedTo": "Számlázva",
            "billingMethod": "Számlázási mód",
            "itemTitle": "Tétel",
            "bookings": "foglalás",
            "customers": "vendég",
            "footer": "Ezt a számla emailt a Fireknife automatikusan generálta.",
            "columns": {
                "invoice": "Számla",
                "dateRange": "Dátumtartomány",
                "created": "Létrehozva",
                "dueDate": "Fizetési határidő",
                "total": "Összesen",
                "id": "ID",
                "contact": "Kapcsolattartó",
                "agent": "Ügynök",
                "voucher": "Voucher",
                "customers": "Vendégek",
                "item": "Tétel",
                "availability": "Időpont",
                "ticketAmount": "Jegy összege",
                "commissionRate": "Jutalék %",
                "commissionAmount": "Jutalék összege",
                "amount": "Összeg",
                "netAmount": "Nettó összeg",
                "amountDue": "Fizetendő összeg"
            }
        },
        "waitlist_seats_available": {
            "title": "Várólistás jelentkezések teljesíthetők",
            "intro": "{{count}} várólistás jelentkező leültethető {{timeslotCount}} időpontra.",
            "andMore": "…és még {{count}}",
            "buttonLabel": "Várólista megnyitása",
            "ticketsCount": "{{count}} jegy"
        },
        "upgrade_eligible_notify": {
            "title": "Frissítésre jogosult foglalások",
            "intro": "{{count}} foglalás {{timeslotCount}} időponton érhető el frissítésre.",
            "eligibleCount": "{{count}} jogosult foglalás",
            "totalValue": "Teljes frissítési érték: {{amount}}",
            "buttonLabel": "Frissítések megtekintése"
        }
    },
    "coupons": {
        "title": "Kuponok",
        "model": "Kupon",
        "columns": {
            "code": "Kód",
            "discountType": "Kedvezmény típusa",
            "value": "Érték",
            "expirationDate": "Lejárati dátum",
            "status": "Státusz",
            "uses": "Felhasználások"
        },
        "discountTypes": {
            "percentage": "Százalék",
            "fixed": "Fix összeg"
        },
        "statuses": {
            "active": "Aktív",
            "expired": "Lejárt",
            "depleted": "Kimerült",
            "inactive": "Inaktív"
        },
        "generate": "Kuponok generálása",
        "export": "Exportálás",
        "quantity": "Mennyiség",
        "maxUses": "Max felhasználások",
        "maxUsesHelp": "Hagyd üresen a korlátlan felhasználáshoz",
        "minOrderAmount": "Minimum rendelési összeg",
        "minOrderAmountHelp": "Hagyd üresen a minimum nélküli használathoz",
        "unlimited": "Korlátlan",
        "useCustomCode": "Egyéni kód használata",
        "customCode": "Egyéni kód",
        "customCodeHelp": "Add meg a kívánt kuponkódot",
        "autoGenerateInfo": "{{count}} egyedi kód automatikusan generálódik",
        "discountSettings": "Kedvezmény beállítások",
        "generationSettings": "Generálási beállítások",
        "codeSettings": "Kód beállítások",
        "preview": "Előnézet",
        "summary": "Összefoglaló",
        "summaryCustom": "{{count}} kupon(ok) ezzel a kóddal: {{code}}",
        "summaryAuto": "{{count}} egyedi kuponkód(ok)",
        "summaryPercent": "{{value}}% kedvezmény",
        "summaryFixed": "${{value}} kedvezmény",
        "notSet": "(nincs beállítva)",
        "minOrderNote": "Minimum rendelés: ${{amount}}",
        "belowMinimum": "Minimum alatt",
        "previewOrder": "Rendelés összege",
        "previewFinal": "Végső ár",
        "previewBelowMin": "Minimum rendelés alatt",
        "previewMinNote": "* Minimum rendelés szükséges: ${{amount}}",
        "enterCode": "Add meg a kuponkódot",
        "apply": "Alkalmaz",
        "verify": "Ellenőrzés",
        "applyCoupon": "Kuponkód alkalmazása",
        "discountApplied": "Kupon alkalmazva: {{discount}}",
        "remove": "Eltávolítás",
        "discount": "Kedvezmény",
        "invalid": "Érvénytelen kuponkód",
        "expired": "Ez a kupon lejárt",
        "depleted": "Ez a kupon már nem elérhető",
        "alreadyUsed": "Ezt a kupont már felhasználtad",
        "minOrderNotMet": "A minimum rendelési összeg nem teljesült",
        "applied": "Kupon alkalmazva!",
        "emailRequired": "Add meg az érvényes e-mail címedet a kupon érvényesítése előtt",
        "cannotDeleteUsed": "Nem törölhető egy már felhasznált kupon",
        "deleteUsedConfirmation": "Ez a kupon már fel lett használva. Törlés helyett letiltásra kerül a felhasználási előzmények megőrzése érdekében. Folytatja?",
        "fields": {
            "maxUses": "Max felhasználás",
            "expirationDate": "Lejárati dátum",
            "isActive": "Aktív"
        },
        "editModal": {
            "title": "Kupon szerkesztése",
            "maxUsesHelp": "Hagyja üresen korlátlan használathoz"
        },
        "notifications": {
            "generated": "{{count}} kupon(ok) sikeresen generálva",
            "generateError": "Hiba a kuponok generálása közben",
            "deleted": "Kupon sikeresen törölve",
            "deleteError": "Hiba a kupon törlésekor",
            "updated": "Kupon sikeresen frissítve",
            "updateError": "Hiba a kupon frissítésekor",
            "codeCopied": "Kód vágólapra másolva",
            "copyError": "Nem sikerült a kód másolása"
        },
        "validation": {
            "positiveValue": "Az értéknek pozitívnak kell lennie",
            "percentageMax": "A százalék nem haladhatja meg a 100-at",
            "percentageMin": "A százaléknak legalább 1-nek kell lennie",
            "quantityMin": "A mennyiségnek legalább 1-nek kell lennie",
            "quantityMax": "A mennyiség nem haladhatja meg az 1000-et",
            "invalidCode": "Érvénytelen kuponkód",
            "inactiveCode": "Ez a kupon már nem aktív",
            "expiredCode": "Ez a kupon lejárt",
            "depletedCode": "Ez a kupon már nem elérhető",
            "belowMinimum": "Minimum rendelési összeg nem teljesült"
        }
    },
    "integrations": {
        "title": "Integrációk",
        "model": "Integráció",
        "configuration": "Konfiguráció",
        "dynamicPricing": {
            "apiKey": "API kulcs",
            "enableToGenerate": "Engedélyezd és mentsd a generáláshoz",
            "description": "Add meg ezt az API kulcsot a Rising Tide-nak. Már ismeri a végpontjainkat - a kulccsal olvassa ki a jövőbeli időpontokat, szabad helyeket és jelenlegi árakat, majd tölti fel az új árakat. A manuálisan beállított időpont-ár mindig felülírja az adott kombinációra feltöltött árat."
        },
        "columns": {
            "status": "Státusz",
            "showTitle": "Előadás címe",
            "name": "Név",
            "type": "Integráció típusa",
            "settings": "Beállítások",
            "accessKey": "Hozzáférési kulcs",
            "supplierId": "Azonosító",
            "enabled": "Engedélyezve",
            "affiliateAgent": "Affiliate ügynök",
            "commissionGroup": "Jutalékcsoport",
            "noCommissionGroup": "Nincs jutalékcsoport"
        },
        "newIntegrationName": "Új integráció",
        "notifications": {
            "added": "Integráció sikeresen hozzáadva.",
            "updated": "Integráció sikeresen frissítve.",
            "deleted": "Integráció sikeresen törölve.",
            "deleteError": "Integráció nem törölhető, mivel foglalások vannak hozzá."
        },
        "validation": {
            "affiliateAgentRequired": "Válassz affiliate ügynököt a kiválasztott jutalékcsoporthoz."
        },
        "description": "Kapcsold össze a {{type}} fiókodat API hitelesítő adatokkal.",
        "activiter": {
            "widgetUrl": "Widget URL",
            "apiUrl": "API URL",
            "apiKey": "API Kulcs",
            "noApiKey": "Engedélyezd az integrációt az API kulcs generálásához",
            "enableToGenerate": "Engedélyezd az integrációt egy API kulcs generálásához",
            "description": "Az API kulcs egy JWT token ami az előadás helyszínéhez van kötve és nem jár le.",
            "apiKeyRegenerated": "API kulcs sikeresen újragenerálva."
        },
        "viatorNetPrices": {
            "title": "Viator Nettó Árak",
            "info": "Állítsd be a Viator foglalások nettó árait. Ezek az árak a Viator jutaléka után kapott összeget jelentik. Csak olyan jegykombinációk konfigurálhatók, amelyeknek van ára a normál ármátrixban.",
            "ticketType": "Jegy típusa",
            "originalPrice": "Eredeti ár",
            "notAvailable": "Nem elérhető - nincs beállított ár a normál ármátrixban",
            "errorLoading": "Hiba a jegy adatok betöltésekor",
            "noTicketsAvailable": "Nincsenek jegytípusok vagy opciók ehhez az előadáshoz"
        },
        "viatorProducts": {
            "title": "Viator termékek (kézi készlet)",
            "info": "Építsd fel a Viator készletet kézzel. Minden termékhez tartozik egy Viator felé megjelenő név és egy jegytípus, és minden korosztályt egy jegyopcióhoz rendel egyedi nettó árral. Az üresen hagyott korosztályok nem jelennek meg. Ha legalább egy termék be van állítva, az felülírja a Viatornak küldött, automatikusan generált terméklistát.",
            "addProduct": "Termék hozzáadása",
            "productName": "Terméknév",
            "ticketType": "Jegy típusa",
            "ageBand": "Korosztály",
            "option": "Jegyopció",
            "price": "Nettó ár",
            "code": "Termékkód",
            "notOffered": "Nem elérhető",
            "errorLoading": "Hiba a jegy adatok betöltésekor",
            "noTickets": "Hozz létre jegytípusokat és opciókat ehhez az előadáshoz, mielőtt Viator termékeket építenél.",
            "codeGeneratedOnSave": "A kód mentéskor jön létre",
            "originalPrice": "Eredeti ár",
            "overridden": "felülírva"
        }
    },
    "invoices": {
        "title": "Számlák",
        "generateTitle": "Számla generálása",
        "generateButton": "Számla generálása",
        "historyTitle": "Számla előzmények",
        "includeDeleted": "Törölt számlák megjelenítése",
        "selectShow": "Válassz előadást",
        "selectCommissionGroup": "Válassz jutalékcsoportot",
        "selectScopeMessage": "A számla generálásához válassz előadást és jutalékcsoportot.",
        "selectHistoryScopeMessage": "A számla előzmények megtekintéséhez válassz előadást és jutalékcsoportot.",
        "deleteConfirm": "Biztosan törölni szeretnéd ezt a számlát?",
        "deleteSuccess": "Számla törölve.",
        "noInvoices": "Nincs számla a kiválasztott szűrőkhöz.",
        "active": "Aktív",
        "deleted": "Törölt",
        "status": "Állapot",
        "batch": "Batch",
        "sentTo": "Küldve",
        "createdAt": "Létrehozva",
        "download": "Letöltés",
        "showOlderBatches": "Régebbi batch-ek megjelenítése ({{count}})",
        "hideOlderBatches": "Régebbi batch-ek elrejtése",
        "charge": "Terhelés",
        "chargeTitle": "Számla terhelése",
        "chargeConfirm": "Biztosan szeretnéd terhelni ezt a számlát az ügynökség kártyájára?",
        "chargeSuccess": "Számla sikeresen terhelve.",
        "invoiceNumber": "Számla #",
        "day": "Nap",
        "addInvoice": "Számla hozzáadása",
        "sendEmail": "E-mail küldése",
        "resendEmail": "E-mail újraküldése",
        "sendEmailSuccess": "Számla e-mail sikeresen elküldve.",
        "emailSent": "E-mail elküldve",
        "tabReceivable": "Követelés",
        "tabPayable": "Kötelezettség"
    },
    "reports": {
        "title": "Riportok",
        "reportType": "Riport típusa",
        "salesReport": "Értékesítési riport",
        "filters": {
            "show": "Előadás",
            "allShows": "Minden előadás",
            "dateFrom": "Dátumtól",
            "dateTo": "Dátumig",
            "showDateFrom": "Előadás dátumtól",
            "showDateTo": "Előadás dátumig",
            "bookingDateFrom": "Foglalás dátumtól",
            "bookingDateTo": "Foglalás dátumig",
            "bookingStatus": "Foglalás státusza",
            "taxBreakout": "Adó bontás megjelenítése",
            "showTicketTypeBreakdown": "Jegytípus bontás megjelenítése",
            "showTicketOptionBreakdown": "Jegyopció bontás megjelenítése",
            "breakdownNoAffiliate": "Nincs partner bontása",
            "breakdownNoAffiliateAgents": "Csoport nélküli ügynökök bontása",
            "hideNoAffiliate": "Nincs partner elrejtése",
            "hideNoGroup": "Csoport nélküli ügynökök elrejtése",
            "includeAllFields": "Minden mező exportálása",
            "integrationSource": "Csak integráció",
            "none": "Nincs",
            "viator": "Viator",
            "venue": "Helyszín",
            "agent": "Ügynök",
            "allAgents": "Minden ügynök",
            "commissionGroup": "Jutalékcsoport",
            "allCommissionGroups": "Minden jutalékcsoport",
            "day": "Nap",
            "clearDates": "Dátumszűrők törlése",
            "paymentType": "Fizetési mód",
            "source": "Forrás",
            "fareharbor": "FareHarbor"
        },
        "columns": {
            "id": "Azonosító",
            "bookingId": "Foglalás azonosító",
            "createdAt": "Létrehozva",
            "contact": "Kapcsolattartó",
            "voucher": "Voucher",
            "customers": "Vendégek",
            "availability": "Elérhetőség",
            "showDate": "Előadás dátuma",
            "amountDue": "Fizetendő összeg",
            "netAmount": "Nettó összeg",
            "taxAmount": "Adó összeg",
            "integrationPrice": "Integrációs ár",
            "processingFee": "Feldolgozási díj",
            "absorbedProcessingFee": "Átvállalt tranzakciós díj",
            "source": "Forrás",
            "commissionGroup": "Jutalékcsoport",
            "bookingStatus": "Foglalás státusza",
            "agent": "Ügynök",
            "unrealisedBalance": "Egyenleg",
            "unrealisedBalanceTooltip": "A rendelés összege és a kiegyenlített fizetések közötti különbség. Pozitív = fizetés szükséges. Negatív = visszatérítés függőben.",
            "bookingFees": "Foglalási díjak",
            "refundedFees": "Visszatérített díjak",
            "netFees": "Nettó díjak",
            "show": "Műsor"
        },
        "summary": {
            "bookings": "{{count}} foglalás",
            "customers": "{{count}} vendég",
            "total": "Összesen",
            "groupTotal": "Csoport összesen",
            "grandTotal": "Végösszeg"
        },
        "tableHeader": "{{showTitle}} - {{ticketTypeName}}",
        "noData": "Nincs adat a kiválasztott szűrőkhöz.",
        "totalAmount": "Teljes összeg",
        "dateRange": "Dátum tartomány",
        "export": "Exportálás Excelbe",
        "exportSuccess": "Riport sikeresen exportálva.",
        "loading": "Riport adatok betöltése...",
        "transactionsReport": "Tranzakciós riport",
        "manifestReport": "Manifest riport",
        "transactions": {
            "totalRecords": "Összes rekord",
            "finished": "Befejezve",
            "pending": "Függőben",
            "columns": {
                "bookingId": "Foglalás azonosító",
                "show": "Előadás",
                "orderId": "Rendelés azonosító",
                "orderAmount": "Rendelés összege",
                "orderStatus": "Rendelés státusza",
                "transactionId": "Tranzakció azonosító",
                "transactionAmount": "Tranzakció összege",
                "transactionStatus": "Tranzakció státusza",
                "paymentType": "Fizetési mód",
                "transactionDate": "Tranzakció dátuma",
                "source": "Forrás"
            }
        },
        "manifest": {
            "columns": {
                "bookingId": "Foglalás azonosító",
                "show": "Előadás",
                "seats": "Helyek",
                "status": "Státusz",
                "createdAt": "Létrehozva"
            }
        },
        "commissionReport": "Jutalék riport",
        "commission": {
            "agentName": "Ügynök",
            "bookingId": "Foglalás",
            "contact": "Kapcsolattartó",
            "showTitle": "Előadás",
            "availability": "Előadás dátuma",
            "customers": "Vendégek",
            "lineTotal": "Sor összesen",
            "commissionGroup": "Jutalékcsoport",
            "commissionAmount": "Jutalék"
        },
        "affiliateSalesReport": "Partneri eladási riport",
        "affiliateSales": {
            "affiliateName": "Partner",
            "ticketType": "Jegytípus",
            "ticketOption": "Jegyopció",
            "bookingCount": "Foglalások",
            "pax": "Fő",
            "totalSales": "Össz. eladás",
            "percentageOfTotal": "Össz. %-a",
            "noAffiliateSection": "Nincs partner",
            "online": "Online",
            "agentsNoGroup": "Ügynökök (nincs jutalékcsoport)"
        },
        "affiliateAgentReport": "Ügynöki teljesítmény riport",
        "affiliateAgent": {
            "agentName": "Ügynök",
            "commissionGroup": "Jutalékcsoport",
            "bookingCount": "Foglalások",
            "totalSales": "Össz. eladás",
            "percentageOfTotal": "Össz. %-a",
            "noGroup": "Nincs csoport"
        },
        "affiliateInvoiceDispatchSuccess": "Számlakiküldés kész: elküldve {{sent}}, kihagyva {{skipped}}, hibás {{failed}}.",
        "affiliateInvoiceDispatchConfirmTitle": "Már vannak aktív számlák",
        "affiliateInvoiceDispatchConfirmMessage": "A kiválasztott időszakra már van aktív számla. Szeretnél újakat generálni és elküldeni?",
        "affiliateInvoiceReport": "Partneri számla riport",
        "affiliateInvoice": {
            "bookingId": "Foglalás",
            "bookingDate": "Foglalás dátuma",
            "contact": "Kapcsolattartó",
            "showTitle": "Műsor",
            "availability": "Műsor dátuma",
            "customers": "Vendégek",
            "grossAmount": "Bruttó összeg",
            "commissionAmount": "Jutalék",
            "netAmount": "Nettó összeg"
        },
        "bookingFeeReport": "Foglalási díj jelentés",
        "affiliateCancelledRefundedReport": "Lemondott/visszatérített partneri foglalások",
        "affiliateCancelledRefunded": {
            "bookingId": "Foglalás",
            "status": "Státusz",
            "commissionGroup": "Jutalékcsoport",
            "agent": "Ügynök",
            "ticketType": "Jegytípus",
            "ticketOption": "Jegyopció",
            "cancellationDate": "Lemondás dátuma",
            "cancellationActor": "Lemondta",
            "cancellationReason": "Ok",
            "originalAmount": "Eredeti összeg",
            "refundedAmount": "Visszatérített összeg",
            "processingFees": "Tranzakciós díj",
            "grandTotal": "Végösszeg"
        },
        "payoutReport": "Kifizetés riport",
        "payout": {
            "line": "Sor",
            "amount": "Összeg",
            "lines": {
                "totalAmount": "Teljes összeg",
                "processingFees": "Tranzakciós díjak",
                "bookingFeesTotal": "Foglalási díjak (összesen)",
                "bookingFeesVenueRebate": "Foglalási díjak - helyszín visszatérítés",
                "bookingFeesFireknife": "Foglalási díjak - Fireknife",
                "netToVenue": "Nettó a helyszínnek"
            },
            "cols": {
                "bookingId": "Foglalás",
                "show": "Műsor",
                "showDate": "Műsor dátuma",
                "paymentType": "Fizetés",
                "source": "Forrás",
                "amount": "Összeg",
                "processingFee": "Tranzakció",
                "bookingFee": "Foglalási díj",
                "venueRebate": "Helyszín visszatérítés",
                "fireknifeFee": "Fireknife díj"
            },
            "excludedAffiliateLabel": "{{amount}} érték {{count}} affiliate foglalásban kizárva."
        }
    },
    "commissionGroups": {
        "manager": "Csoportvezető",
        "canEditBookings": "Tagok foglalásainak szerkesztése",
        "canEditBookingsHint": "A jutalékcsoport ügynökei által létrehozott foglalások szerkesztése, nem csak a sajátjai.",
        "managementTitle": "Partnerek kezelése",
        "title": "Jutalékcsoportok",
        "model": "Jutalékcsoport",
        "columns": {
            "name": "Név",
            "commissionMatrix": "Jutalék mátrix",
            "affiliateContactEmail": "Partner kapcsolattartó email",
            "billingType": "Számlázási típus"
        },
        "assignmentAffiliateCode": {
            "label": "Partner kód",
            "placeholder": "activityauthority",
            "setCode": "Partner kód megadása",
            "dialogTitle": "Partner kód",
            "help": "A widget URL-ben ?affiliate=<kód> alakban használható. Az ezen a linken keresztül érkező foglalások automatikusan ehhez a felhasználóhoz kerülnek erre az előadásra. Hagyd üresen, ha nincs attribúció.",
            "invalid": "Csak betűk, számok, kötőjelek, alulvonások (max. 64 karakter).",
            "bookingLinkLabel": "Foglalási link",
            "directLinkLabel": "Közvetlen foglalási link",
            "embedSnippetLabel": "Beágyazó kódrészlet (partneroldalra illeszthető HTML)",
            "buttonSnippetLabel": "Gomb-kódrészlet (meglévő partner gombokhoz)",
            "copy": "Másolás",
            "shortDirectLink": "Link",
            "shortEmbed": "Beágyazó",
            "shortButton": "Gomb",
            "unsavedHint": "Csak előnézet — mentsd el, hogy aktívvá tedd a kódrészleteket."
        },
        "members": {
            "title": "Partnerek és ügynökök",
            "description": "A meghívás létrehozza a fiókot és kiküld egy üdvözlő e-mailt - partnerkód létrehozása esetén a foglalási linkkel együtt. Meglévő tag meghívása újraküldi ezt az üdvözlő e-mailt.",
            "affiliateCode": "Partner kód",
            "showBookingLinks": "Foglalási linkek megjelenítése",
            "resendWelcome": "Üdvözlő e-mail újraküldése",
            "inviteHelp": "Kapni fog egy üdvözlő e-mailt - partnerkód létrehozása esetén a foglalási linkjével együtt.",
            "emptyState": "Még nincs partner - hívjon meg egyet, és e-mailben megkapja a foglalási linkjét.",
            "inviteWithCode": "Partnerkód és foglalási link létrehozása",
            "rowActions": "Tag műveletek",
            "copyBookingLink": "Foglalási link másolása",
            "copyEmbedCode": "Beágyazó kód másolása",
            "showSnippets": "Foglalási linkek és beágyazás megjelenítése",
            "hideSnippets": "Foglalási linkek és beágyazás elrejtése",
            "copied": "Vágólapra másolva",
            "welcomeSentAt": "Üdvözlő elküldve: {{- date}}",
            "inviteAsManager": "Meghívás menedzserként",
            "makeManager": "Kinevezés menedzserré",
            "revokeManager": "Menedzseri jog visszavonása",
            "allowBookingEdits": "Foglalások szerkesztésének engedélyezése",
            "roleUpdated": "Tag szerepköre frissítve",
            "status": {
                "column": "Státusz",
                "pending": "Függőben",
                "active": "Aktív",
                "pendingTooltip": "Meghívva - még nem hozta létre a jelszavát"
            }
        },
        "tabs": {
            "settings": "Beállítások",
            "affiliates": "Partnerek"
        },
        "partnerCard": {
            "title": "Partner elmentett kártyája",
            "setupLinkHelp": "Fizetési beállítási link (oszd meg a partnerrel kártya vagy bankszámla hozzáadásához):",
            "setupButton": "Stripe ügyfél létrehozása",
            "created": "Stripe ügyfél létrehozva"
        },
        "checklists": {
            "ar": {
                "title": "Nettó számlázás (A/R) - az ügynök szedi be a fizetést",
                "onHouseOnly": "Korlátozd a csoportot kizárólag „házon belüli” fizetési módokra (az ügynök szedi be a készpénzt vagy a kártyás fizetést a vendégtől)",
                "markAgentCollected": "Jelöld be az „Ügynök szedi be” opciót ezeknél a fizetési módoknál az alábbi táblázatban",
                "invoice": "A számlán a teljes jegyérték mínusz a jutalék jelenik meg (amivel az ügynök tartozik a helyszínnek)"
            },
            "ap": {
                "title": "Ajánlás (A/P) - a helyszín szedi be a fizetést",
                "venueCollected": "Korlátozd a csoportot a helyszín által beszedett fizetési módokra (a helyszín kezeli a kártyát vagy a készpénzt)",
                "notAgentCollected": "NE jelöld be az „Ügynök szedi be” opciót a fizetési módoknál",
                "invoice": "A számlán a jutalék összege jelenik meg (amivel a helyszín tartozik az ügynöknek)"
            },
            "deposit": {
                "title": "Ajánlási előleg - Stripe Connect megosztás",
                "createCardMethod": "Hozz létre egy új „kártya” fizetési módot bekapcsolt Stripe Connecttel",
                "limitToThatMethod": "Korlátozd a jutalékcsoportot kizárólag erre a fizetési módra",
                "platformFee": "A platformdíj automatikusan a teljes összeg mínusz a jutalék lesz",
                "connectReceives": "A Connect fiók kapja meg a jutalék részét"
            },
            "card": {
                "title": "Elmentett kártya - automatikus számlázás",
                "onHouseOnly": "Korlátozd a csoportot „házon belüli” fizetési módokra (az ügynök szedi be)",
                "setupCustomer": "Hozz létre lent egy Stripe ügyfelet, és oszd meg a fizetési linket a partnerrel",
                "partnerAddsCard": "A partner a fizetési beállítási linken keresztül adja hozzá a kártyáját vagy bankszámláját",
                "autoBill": "Készíts számlákat, és a „Terhelés” gombbal terheld automatikusan a partnert",
                "pastEventsLocked": "Az ügynökök nem módosíthatják a már lezajlott események foglalásait, így a számlák sértetlenek maradnak"
            },
            "transfer": {
                "title": "ACH / banki átutalás - elmentett kártya v2",
                "sameAsCard": "Ugyanaz a beállítás, mint a fenti „Elmentett kártya” esetén",
                "partnerAddsBank": "A partner kártya helyett bankszámlát (ACH) ad hozzá a fizetési beállítási linken keresztül",
                "async": "Az ACH fizetések aszinkronok - az állapotfrissítések Stripe webhookon keresztül érkeznek"
            }
        },
        "newCommissionGroupTitle": "Új jutalékcsoport",
        "matrixType": {
            "percentage": "Százalékos (%)",
            "fixed": "Fix összeg ($)"
        },
        "matrixInfo": "Állítsa be a jutalékot jegytípus és jegyopció kombinációnként. Hagyja üresen, ha nincs jutalék.",
        "guestVisibleLockedInfo": "A nyilvánosan elérhető (guest-visible) tételek mindig engedélyezettek, ezért a jelölőnégyzetük zárolt.",
        "sellPermissionsTitle": "Értékesítési jogosultságok",
        "sellPermissionsInfo": "Állítsd be, hogy ez a jutalékcsoport mely jegytípus + jegyopció kombinációkat értékesítheti.",
        "commissionValuesTitle": "Jutalék értékek",
        "commissionValuesInfo": "Add meg a jutalékot jegytípus és jegyopció kombinációnként. Üresen hagyva nincs jutalék.",
        "allOptions": "Mind",
        "noTicketTypesOrOptions": "Nincsenek elérhető jegytípusok vagy jegyopciók ehhez az előadáshoz.",
        "commissionType": "Típus",
        "commissionValue": "Érték",
        "assignments": "Jutalékcsoport hozzárendelések",
        "assignmentsInfo": "Rendeljen jutalékcsoportot előadásonként ehhez a felhasználóhoz. Előadásonként csak egy jutalékcsoport rendelhető hozzá.",
        "noAssignment": "Nincs",
        "notifications": {
            "added": "Jutalékcsoport sikeresen hozzáadva.",
            "updated": "Jutalékcsoport sikeresen frissítve.",
            "deleted": "Jutalékcsoport sikeresen törölve.",
            "deleteError": "A jutalékcsoport nem törölhető.",
            "assigned": "Jutalékcsoport sikeresen hozzárendelve.",
            "removed": "Jutalékcsoport hozzárendelés sikeresen eltávolítva.",
            "assignError": "Hiba a jutalékcsoport hozzárendelésekor.",
            "removeError": "Hiba a jutalékcsoport hozzárendelés eltávolításakor.",
            "agentInvited": "Az ügynök sikeresen meghívva.",
            "welcomeResent": "Üdvözlő e-mail újraküldve.",
            "agentInviteError": "Az ügynök meghívása sikertelen. Ellenőrizd az e-mail címet.",
            "agentRemoved": "Ügynök eltávolítva a jutalékcsoportból. A helyszínhez tartozó hozzáférése megmarad - a teljes eltávolításhoz fordulj adminisztrátorhoz.",
            "agentRemoveError": "Hiba az ügynök eltávolítása során."
        },
        "affiliateContactEmailPlaceholder": "billing@example.com, accounting@example.com",
        "affiliateContactEmailHelp": "Több email címet is megadhatsz vesszővel elválasztva.",
        "dynamicPricing": {
            "label": "Dinamikus árazás engedélyezése",
            "help": "Ha be van kapcsolva (és a műsor dinamikus árazás integrációja is engedélyezve van), az ebben a jutalékcsoportban lévő ügynökök dinamikus áron foglalnak. A megkerülés jogosultsággal rendelkező ügynökök mindig az eredeti áron foglalnak."
        },
        "billingType": {
            "placeholder": "Válassz számlázási típust",
            "infoAriaLabel": "Számlázási típus magyarázatok",
            "options": {
                "ar": "Nettó számlázás (A/R)",
                "ap": "Utalvány (A/P)",
                "deposit": "Ajánlási deposit",
                "card": "Előre mentett kártya",
                "transfer": "ACH"
            },
            "descriptions": {
                "ar": "A partner (ügynökség) gyűjti össze a vendégtől a pénzt, és a hónap végén rendezi a számlát a helyszínnel.",
                "ap": "A helyszín gyűjti össze a pénzt, és a hónap végén kifizeti a jutalékot a partnernek.",
                "deposit": "A vendég kártyával fizet, de a tranzakció azonnal felosztásra kerül (Stripe Connect). A vendég két külön díjat lát: egyet a helyszín nettó áráért, egyet az ügynökség jutalékáért.",
                "card": "Megbízható partnereknek a rendszer menti a kártya adatait, és az kiadott számla alapján automatikusan terheli.",
                "transfer": "Bankról bankra átutalás Stripe-on keresztül, ami csökkenti a kártyatranzakciós díjakat."
            }
        },
        "management": {
            "members": "Tagok",
            "bookings": "Foglalások",
            "inviteAgent": "Ügynök meghívása",
            "inviteAgentTitle": "Ügynök meghívása",
            "inviteAgentName": "Ügynök neve",
            "inviteAgentEmail": "Ügynök e-mail címe",
            "inviteAgentSubmit": "Meghívás",
            "noMembers": "Még nincs ügynök ebben a csoportban.",
            "noBookings": "Nincs foglalás ebben a csoportban.",
            "noGroups": "Nincs jutalékcsoport ehhez a helyszínhez.",
            "removeAgent": "Ügynök eltávolítása",
            "selectGroup": "Jutalékcsoport",
            "memberColumns": {
                "name": "Név",
                "email": "E-mail",
                "role": "Szerepkör",
                "manager": "Vezető",
                "agent": "Ügynök"
            },
            "bookingColumns": {
                "agent": "Ügynök",
                "booking": "Foglalás #",
                "contact": "Kapcsolattartó",
                "availability": "Dátum",
                "customers": "Jegyek",
                "lineTotal": "Összeg",
                "commission": "Jutalék",
                "status": "Státusz"
            }
        }
    },
    "admin": {
        "seatingGroup": {
            "connectButton": "Csoporthoz kapcsolás",
            "modalTitleNew": "Ülőhelycsoport csatlakoztatása",
            "modalTitleExisting": "{{n}}. ülőhelycsoport",
            "searchPlaceholderLabel": "Foglalás keresése",
            "searchPlaceholder": "Keresés név, e-mail vagy foglalási kód alapján",
            "createGroup": "Csoport létrehozása",
            "disband": "Csoport feloszlatása",
            "disbandSuccess": "Csoport feloszlatva",
            "groupCreated": "Ülőhelycsoport létrehozva",
            "membersAdded": "Tagok hozzáadva",
            "memberRemoved": "Tag eltávolítva",
            "guestNote": "A vendég írta:",
            "badge": "{{n}}. csoport",
            "currentMembers": "Jelenlegi tagok",
            "thisBooking": "Ez a foglalás",
            "removeMember": "Eltávolítás a csoportból",
            "wantsToSitWith": "Együtt szeretne ülni",
            "seatGroup": "Csoport elhelyezése",
            "addMembers": "Hozzáadás a csoporthoz",
            "noResults": "Ehhez az időponthoz nem találhatók más foglalások",
            "unseatGroup": "Csoport ülőhelyek törlése",
            "nameLabel": "Csoport neve (opcionális)",
            "namePlaceholder": "pl. Kovács társaság",
            "saveName": "Név mentése",
            "nameSaved": "Csoport neve mentve"
        }
    }
}
